

window.jooneDataLayerVariants = {

  
    
      "32894592614423": {
        variant_title: "1 mois",
        product_title: "Abonnement Cadeau",
        price: '69.90',
        sku: "GIFT-CARD-1M",
        product_type: "category_bb_hygiene",
        url: "/products/abonnement-cadeau-joone?variant=32894592614423"
      },
    
      "6965915451425": {
        variant_title: "3 mois",
        product_title: "Abonnement Cadeau",
        price: '209.90',
        sku: "GIFT-CARD-3M",
        product_type: "category_bb_hygiene",
        url: "/products/abonnement-cadeau-joone?variant=6965915451425"
      },
    
      "6965918105633": {
        variant_title: "6 mois",
        product_title: "Abonnement Cadeau",
        price: '399.90',
        sku: "GIFT-CARD-6M",
        product_type: "category_bb_hygiene",
        url: "/products/abonnement-cadeau-joone?variant=6965918105633"
      },
    
      "6965918138401": {
        variant_title: "12 mois",
        product_title: "Abonnement Cadeau",
        price: '759.90',
        sku: "GIFT-CARD-12M",
        product_type: "category_bb_hygiene",
        url: "/products/abonnement-cadeau-joone?variant=6965918138401"
      },
    
  
    
      "33037524992023": {
        variant_title: "Malo / Mix couches-culottes / couches / T4 - 90 couches-culottes  + 36 couches FSC Mix*",
        product_title: "Abonnement couches-culottes seules FSC Mix*",
        price: '64.90',
        sku: "B.CC.IDV.C.ML.PE.T4",
        product_type: "",
        url: "/products/abonnement-couches-culottes-seules?variant=33037524992023"
      },
    
      "27966087495703": {
        variant_title: "Malo / Mix couches-culottes / couches / T5 - 84 couches-culottes  + 40 couches FSC Mix*",
        product_title: "Abonnement couches-culottes seules FSC Mix*",
        price: '64.90',
        sku: "B.CC.IDV.C.ML.PE.T5",
        product_type: "",
        url: "/products/abonnement-couches-culottes-seules?variant=27966087495703"
      },
    
      "27966087561239": {
        variant_title: "Malo / Mix couches-culottes / couches / T6 - 78 couches-culottes  + 38 couches FSC Mix*",
        product_title: "Abonnement couches-culottes seules FSC Mix*",
        price: '64.90',
        sku: "B.CC.IDV.C.ML.PE.T6",
        product_type: "",
        url: "/products/abonnement-couches-culottes-seules?variant=27966087561239"
      },
    
      "33037525811223": {
        variant_title: "Malo / couches-culottes only / T4 - 120 couches-culottes FSC Mix*",
        product_title: "Abonnement couches-culottes seules FSC Mix*",
        price: '64.90',
        sku: "B.CC.IDV.ML.T4",
        product_type: "",
        url: "/products/abonnement-couches-culottes-seules?variant=33037525811223"
      },
    
      "27966093983767": {
        variant_title: "Malo / couches-culottes only / T5 - 112 couches-culottes FSC Mix*",
        product_title: "Abonnement couches-culottes seules FSC Mix*",
        price: '64.90',
        sku: "B.CC.IDV.ML.T5",
        product_type: "",
        url: "/products/abonnement-couches-culottes-seules?variant=27966093983767"
      },
    
      "27966101159959": {
        variant_title: "Malo / couches-culottes only / T6 - 104 couches-culottes FSC Mix*",
        product_title: "Abonnement couches-culottes seules FSC Mix*",
        price: '64.90',
        sku: "B.CC.IDV.ML.T6",
        product_type: "",
        url: "/products/abonnement-couches-culottes-seules?variant=27966101159959"
      },
    
      "33037525024791": {
        variant_title: "Brigitte / Mix couches-culottes / couches / T4 - 90 couches-culottes  + 36 couches FSC Mix*",
        product_title: "Abonnement couches-culottes seules FSC Mix*",
        price: '64.90',
        sku: "B.CC.IDV.C.RC.PE.T4",
        product_type: "",
        url: "/products/abonnement-couches-culottes-seules?variant=33037525024791"
      },
    
      "27966087528471": {
        variant_title: "Brigitte / Mix couches-culottes / couches / T5 - 84 couches-culottes  + 40 couches FSC Mix*",
        product_title: "Abonnement couches-culottes seules FSC Mix*",
        price: '64.90',
        sku: "B.CC.IDV.C.RC.PE.T5",
        product_type: "",
        url: "/products/abonnement-couches-culottes-seules?variant=27966087528471"
      },
    
      "27966087594007": {
        variant_title: "Brigitte / Mix couches-culottes / couches / T6 - 78 couches-culottes  + 38 couches FSC Mix*",
        product_title: "Abonnement couches-culottes seules FSC Mix*",
        price: '64.90',
        sku: "B.CC.IDV.C.RC.PE.T6",
        product_type: "",
        url: "/products/abonnement-couches-culottes-seules?variant=27966087594007"
      },
    
      "33037525843991": {
        variant_title: "Brigitte / couches-culottes only / T4 - 120 couches-culottes FSC Mix*",
        product_title: "Abonnement couches-culottes seules FSC Mix*",
        price: '64.90',
        sku: "B.CC.IDV.RC.T4",
        product_type: "",
        url: "/products/abonnement-couches-culottes-seules?variant=33037525843991"
      },
    
      "27966094147607": {
        variant_title: "Brigitte / couches-culottes only / T5 - 112 couches-culottes FSC Mix*",
        product_title: "Abonnement couches-culottes seules FSC Mix*",
        price: '64.90',
        sku: "B.CC.IDV.RC.T5",
        product_type: "",
        url: "/products/abonnement-couches-culottes-seules?variant=27966094147607"
      },
    
      "27966101782551": {
        variant_title: "Brigitte / couches-culottes only / T6 - 104 couches-culottes FSC Mix*",
        product_title: "Abonnement couches-culottes seules FSC Mix*",
        price: '64.90',
        sku: "B.CC.IDV.RC.T6",
        product_type: "",
        url: "/products/abonnement-couches-culottes-seules?variant=27966101782551"
      },
    
      "39391421267991": {
        variant_title: "Bernard / Mix couches-culottes / couches / T4 - 90 couches-culottes  + 36 couches FSC Mix*",
        product_title: "Abonnement couches-culottes seules FSC Mix*",
        price: '64.90',
        sku: "B.CC.IDV.C.BE.PE.T4",
        product_type: "",
        url: "/products/abonnement-couches-culottes-seules?variant=39391421267991"
      },
    
      "39391421300759": {
        variant_title: "Bernard / Mix couches-culottes / couches / T5 - 84 couches-culottes  + 40 couches FSC Mix*",
        product_title: "Abonnement couches-culottes seules FSC Mix*",
        price: '64.90',
        sku: "B.CC.IDV.C.BE.PE.T5",
        product_type: "",
        url: "/products/abonnement-couches-culottes-seules?variant=39391421300759"
      },
    
      "39391421333527": {
        variant_title: "Bernard / Mix couches-culottes / couches / T6 - 78 couches-culottes  + 38 couches FSC Mix*",
        product_title: "Abonnement couches-culottes seules FSC Mix*",
        price: '64.90',
        sku: "B.CC.IDV.C.BE.PE.T6",
        product_type: "",
        url: "/products/abonnement-couches-culottes-seules?variant=39391421333527"
      },
    
      "39391421366295": {
        variant_title: "Bernard / couches-culottes only / T4 - 120 couches-culottes FSC Mix*",
        product_title: "Abonnement couches-culottes seules FSC Mix*",
        price: '64.90',
        sku: "B.CC.IDV.BE.T4",
        product_type: "",
        url: "/products/abonnement-couches-culottes-seules?variant=39391421366295"
      },
    
      "39391421431831": {
        variant_title: "Bernard / couches-culottes only / T5 - 112 couches-culottes FSC Mix*",
        product_title: "Abonnement couches-culottes seules FSC Mix*",
        price: '64.90',
        sku: "B.CC.IDV.BE.T5",
        product_type: "",
        url: "/products/abonnement-couches-culottes-seules?variant=39391421431831"
      },
    
      "39391421464599": {
        variant_title: "Bernard / couches-culottes only / T6 - 104 couches-culottes FSC Mix*",
        product_title: "Abonnement couches-culottes seules FSC Mix*",
        price: '64.90',
        sku: "B.CC.IDV.BE.T6",
        product_type: "",
        url: "/products/abonnement-couches-culottes-seules?variant=39391421464599"
      },
    
  
    
      "27888828678167": {
        variant_title: "couches seules (FSC Mix)",
        product_title: "Abonnement Joone",
        price: '64.90',
        sku: "JOONECHARGE.BUNDLE.C.V1",
        product_type: "category_bb_hygiene",
        url: "/products/abonnement-couche?variant=27888828678167"
      },
    
      "29385794322455": {
        variant_title: "couches-culottes seules (FSC Mix)",
        product_title: "Abonnement Joone",
        price: '64.90',
        sku: "JOONECHARGE.BUNDLE.CC.V1",
        product_type: "category_bb_hygiene",
        url: "/products/abonnement-couche?variant=29385794322455"
      },
    
      "29385797992471": {
        variant_title: "mix couches-culottes & couches (FSC Mix) + lingettes",
        product_title: "Abonnement Joone",
        price: '69.90',
        sku: "JOONECHARGE.BUNDLE.CCL.C.V1",
        product_type: "category_bb_hygiene",
        url: "/products/abonnement-couche?variant=29385797992471"
      },
    
      "27888828743703": {
        variant_title: "couches (FSC Mix) + soin",
        product_title: "Abonnement Joone",
        price: '74.80',
        sku: "JOONECHARGE.BUNDLE.CS.V1",
        product_type: "category_bb_hygiene",
        url: "/products/abonnement-couche?variant=27888828743703"
      },
    
      "29385798418455": {
        variant_title: "couches-culottes (FSC Mix) + soin",
        product_title: "Abonnement Joone",
        price: '74.80',
        sku: "JOONECHARGE.BUNDLE.CCS.V1",
        product_type: "category_bb_hygiene",
        url: "/products/abonnement-couche?variant=29385798418455"
      },
    
      "29385801236503": {
        variant_title: "mix couches-culottes & couches (FSC Mix) + soin",
        product_title: "Abonnement Joone",
        price: '74.80',
        sku: "JOONECHARGE.BUNDLE.CCS.C.V1",
        product_type: "category_bb_hygiene",
        url: "/products/abonnement-couche?variant=29385801236503"
      },
    
      "27888828776471": {
        variant_title: "couches (FSC Mix) + lingettes + soin",
        product_title: "Abonnement Joone",
        price: '79.80',
        sku: "JOONECHARGE.BUNDLE.CLS.V1",
        product_type: "category_bb_hygiene",
        url: "/products/abonnement-couche?variant=27888828776471"
      },
    
      "29385801564183": {
        variant_title: "couches-culottes (FSC Mix) + lingettes + soin",
        product_title: "Abonnement Joone",
        price: '79.80',
        sku: "JOONECHARGE.BUNDLE.CCLS.V1",
        product_type: "category_bb_hygiene",
        url: "/products/abonnement-couche?variant=29385801564183"
      },
    
      "40535954194455": {
        variant_title: "couches (FSC Mix) + cotons + 1 soin",
        product_title: "Abonnement Joone",
        price: '80.70',
        sku: "JOONECHARGE.BUNDLE.CPS.V1",
        product_type: "category_bb_hygiene",
        url: "/products/abonnement-couche?variant=40535954194455"
      },
    
      "40535954227223": {
        variant_title: "couches (FSC Mix) + cotons + 2 soins",
        product_title: "Abonnement Joone",
        price: '90.60',
        sku: "JOONECHARGE.BUNDLE.CPSS.V1",
        product_type: "category_bb_hygiene",
        url: "/products/abonnement-couche?variant=40535954227223"
      },
    
      "40535954259991": {
        variant_title: "couches (FSC Mix) + cotons + lingettes",
        product_title: "Abonnement Joone",
        price: '75.80',
        sku: "JOONECHARGE.BUNDLE.CPL.V1",
        product_type: "category_bb_hygiene",
        url: "/products/abonnement-couche?variant=40535954259991"
      },
    
      "40535954325527": {
        variant_title: "couches (FSC Mix) + cotons + lingettes + 2 soins",
        product_title: "Abonnement Joone",
        price: '95.60',
        sku: "JOONECHARGE.BUNDLE.CPLSS.V1",
        product_type: "category_bb_hygiene",
        url: "/products/abonnement-couche?variant=40535954325527"
      },
    
      "40535954391063": {
        variant_title: "couches (FSC Mix) + 2 soins",
        product_title: "Abonnement Joone",
        price: '84.70',
        sku: "JOONECHARGE.BUNDLE.CSS.V1",
        product_type: "category_bb_hygiene",
        url: "/products/abonnement-couche?variant=40535954391063"
      },
    
      "40535954456599": {
        variant_title: "couches-culottes (FSC Mix) + cotons + 1 soin",
        product_title: "Abonnement Joone",
        price: '80.70',
        sku: "JOONECHARGE.BUNDLE.CCPS.V1",
        product_type: "category_bb_hygiene",
        url: "/products/abonnement-couche?variant=40535954456599"
      },
    
      "40535954489367": {
        variant_title: "couches-culottes (FSC Mix) + cotons + 2 soins",
        product_title: "Abonnement Joone",
        price: '90.60',
        sku: "JOONECHARGE.BUNDLE.CCPSS.V1",
        product_type: "category_bb_hygiene",
        url: "/products/abonnement-couche?variant=40535954489367"
      },
    
      "40535954522135": {
        variant_title: "couches-culottes (FSC Mix) + cotons + lingettes",
        product_title: "Abonnement Joone",
        price: '75.80',
        sku: "JOONECHARGE.BUNDLE.CCPL.V1",
        product_type: "category_bb_hygiene",
        url: "/products/abonnement-couche?variant=40535954522135"
      },
    
      "40535954554903": {
        variant_title: "couches-culottes (FSC Mix) + cotons + lingettes + 1 soin",
        product_title: "Abonnement Joone",
        price: '85.70',
        sku: "JOONECHARGE.BUNDLE.CCPLS.V1",
        product_type: "category_bb_hygiene",
        url: "/products/abonnement-couche?variant=40535954554903"
      },
    
      "40535954620439": {
        variant_title: "couches-culottes (FSC Mix) + lingettes + 2 soins",
        product_title: "Abonnement Joone",
        price: '89.70',
        sku: "JOONECHARGE.BUNDLE.CCLSS.V1",
        product_type: "category_bb_hygiene",
        url: "/products/abonnement-couche?variant=40535954620439"
      },
    
      "40535954653207": {
        variant_title: "couches-culottes (FSC Mix) + 2 soins",
        product_title: "Abonnement Joone",
        price: '84.70',
        sku: "JOONECHARGE.BUNDLE.CCSS.V1",
        product_type: "category_bb_hygiene",
        url: "/products/abonnement-couche?variant=40535954653207"
      },
    
      "40535954718743": {
        variant_title: "mix couches & couches-culottes (FSC Mix) + cotons + 1 soin",
        product_title: "Abonnement Joone",
        price: '80.70',
        sku: "JOONECHARGE.BUNDLE.CCPS.C.V1",
        product_type: "category_bb_hygiene",
        url: "/products/abonnement-couche?variant=40535954718743"
      },
    
      "40535954751511": {
        variant_title: "mix couches & couches-culottes (FSC Mix) + cotons + 2 soins",
        product_title: "Abonnement Joone",
        price: '90.60',
        sku: "JOONECHARGE.BUNDLE.CCPSS.C.V1",
        product_type: "category_bb_hygiene",
        url: "/products/abonnement-couche?variant=40535954751511"
      },
    
      "40535954784279": {
        variant_title: "mix couches & couches-culottes (FSC Mix) + cotons + lingettes",
        product_title: "Abonnement Joone",
        price: '75.80',
        sku: "JOONECHARGE.BUNDLE.CCPL.C.V1",
        product_type: "category_bb_hygiene",
        url: "/products/abonnement-couche?variant=40535954784279"
      },
    
      "40535954817047": {
        variant_title: "mix couches & couches-culottes (FSC Mix) + cotons + lingettes + 1 soin",
        product_title: "Abonnement Joone",
        price: '85.70',
        sku: "JOONECHARGE.BUNDLE.CCPLS.C.V1",
        product_type: "category_bb_hygiene",
        url: "/products/abonnement-couche?variant=40535954817047"
      },
    
      "40535954849815": {
        variant_title: "mix couches & couches-culottes (FSC Mix) + cotons + lingettes + 2 soins",
        product_title: "Abonnement Joone",
        price: '95.60',
        sku: "JOONECHARGE.BUNDLE.CCPLSS.C.V1",
        product_type: "category_bb_hygiene",
        url: "/products/abonnement-couche?variant=40535954849815"
      },
    
      "40535954882583": {
        variant_title: "mix couches & couches-culottes (FSC Mix) + lingettes  + 2 soins",
        product_title: "Abonnement Joone",
        price: '89.70',
        sku: "JOONECHARGE.BUNDLE.CCLSS.C.V1",
        product_type: "category_bb_hygiene",
        url: "/products/abonnement-couche?variant=40535954882583"
      },
    
      "40535954915351": {
        variant_title: "mix couches & couches-culottes (FSC Mix) + 2 soins",
        product_title: "Abonnement Joone",
        price: '84.70',
        sku: "JOONECHARGE.BUNDLE.CCSS.C.V1",
        product_type: "category_bb_hygiene",
        url: "/products/abonnement-couche?variant=40535954915351"
      },
    
      "29385795239959": {
        variant_title: "mix couches-culottes & couches seules (FSC Mix)",
        product_title: "Abonnement Joone",
        price: '64.90',
        sku: "JOONECHARGE.BUNDLE.CC.C.V1",
        product_type: "category_bb_hygiene",
        url: "/products/abonnement-couche?variant=29385795239959"
      },
    
      "27888828710935": {
        variant_title: "couches (FSC Mix) + lingettes (COSMOS NATURAL)",
        product_title: "Abonnement Joone",
        price: '69.90',
        sku: "JOONECHARGE.BUNDLE.CL.V1",
        product_type: "category_bb_hygiene",
        url: "/products/abonnement-couche?variant=27888828710935"
      },
    
      "29385795338263": {
        variant_title: "couches-culottes (FSC Mix) + lingettes (COSMOS NATURAL)",
        product_title: "Abonnement Joone",
        price: '69.90',
        sku: "JOONECHARGE.BUNDLE.CCL.V1",
        product_type: "category_bb_hygiene",
        url: "/products/abonnement-couche?variant=29385795338263"
      },
    
      "29385808412695": {
        variant_title: "mix couches-culottes & couches (FSC Mix) + lingettes + soin",
        product_title: "Abonnement Joone",
        price: '79.80',
        sku: "JOONECHARGE.BUNDLE.CCLS.C.V1",
        product_type: "category_bb_hygiene",
        url: "/products/abonnement-couche?variant=29385808412695"
      },
    
      "31502211973143": {
        variant_title: "serviettes hygièniques parfaites 1 boîte",
        product_title: "Abonnement Joone",
        price: '5.90',
        sku: "JOONECHARGE.BUNDLE.NAPKIN.1",
        product_type: "category_bb_hygiene",
        url: "/products/abonnement-couche?variant=31502211973143"
      },
    
      "31502214332439": {
        variant_title: "serviettes hygièniques parfaites 2 boîtes",
        product_title: "Abonnement Joone",
        price: '11.80',
        sku: "JOONECHARGE.BUNDLE.NAPKIN.2",
        product_type: "category_bb_hygiene",
        url: "/products/abonnement-couche?variant=31502214332439"
      },
    
      "31509553348631": {
        variant_title: "serviettes hygièniques parfaites 3 boîtes",
        product_title: "Abonnement Joone",
        price: '17.70',
        sku: "JOONECHARGE.BUNDLE.NAPKIN.3",
        product_type: "category_bb_hygiene",
        url: "/products/abonnement-couche?variant=31509553348631"
      },
    
      "31502215315479": {
        variant_title: "serviettes hygièniques parfaites 4 boîtes",
        product_title: "Abonnement Joone",
        price: '23.60',
        sku: "JOONECHARGE.BUNDLE.NAPKIN.4",
        product_type: "category_bb_hygiene",
        url: "/products/abonnement-couche?variant=31502215315479"
      },
    
      "31502218067991": {
        variant_title: "serviettes hygièniques parfaites 5 boîtes",
        product_title: "Abonnement Joone",
        price: '29.50',
        sku: "JOONECHARGE.BUNDLE.NAPKIN.5",
        product_type: "category_bb_hygiene",
        url: "/products/abonnement-couche?variant=31502218067991"
      },
    
      "31502218723351": {
        variant_title: "serviettes hygièniques parfaites 6 boîtes",
        product_title: "Abonnement Joone",
        price: '35.40',
        sku: "JOONECHARGE.BUNDLE.NAPKIN.6",
        product_type: "category_bb_hygiene",
        url: "/products/abonnement-couche?variant=31502218723351"
      },
    
      "31502219935767": {
        variant_title: "serviettes hygièniques parfaites 7 boîtes",
        product_title: "Abonnement Joone",
        price: '41.30',
        sku: "JOONECHARGE.BUNDLE.NAPKIN.7",
        product_type: "category_bb_hygiene",
        url: "/products/abonnement-couche?variant=31502219935767"
      },
    
      "31502221115415": {
        variant_title: "serviettes hygièniques parfaites 8 boîtes",
        product_title: "Abonnement Joone",
        price: '47.20',
        sku: "JOONECHARGE.BUNDLE.NAPKIN.8",
        product_type: "category_bb_hygiene",
        url: "/products/abonnement-couche?variant=31502221115415"
      },
    
      "31502223179799": {
        variant_title: "serviettes hygièniques parfaites 9 boîtes",
        product_title: "Abonnement Joone",
        price: '53.10',
        sku: "JOONECHARGE.BUNDLE.NAPKIN.9",
        product_type: "category_bb_hygiene",
        url: "/products/abonnement-couche?variant=31502223179799"
      },
    
      "31502225014807": {
        variant_title: "serviettes hygièniques parfaites 10 boîtes",
        product_title: "Abonnement Joone",
        price: '59.00',
        sku: "JOONECHARGE.BUNDLE.NAPKIN.10",
        product_type: "category_bb_hygiene",
        url: "/products/abonnement-couche?variant=31502225014807"
      },
    
      "40529620631575": {
        variant_title: "couches seules One (FSC Mix)",
        product_title: "Abonnement Joone",
        price: '54.90',
        sku: "JOONECHARGE.BUNDLE.C.ONE.V1",
        product_type: "category_bb_hygiene",
        url: "/products/abonnement-couche?variant=40529620631575"
      },
    
      "40529724604439": {
        variant_title: "couches seules Origine (FSC Mix)",
        product_title: "Abonnement Joone",
        price: '74.90',
        sku: "JOONECHARGE.BUNDLE.C.ORI.V1",
        product_type: "category_bb_hygiene",
        url: "/products/abonnement-couche?variant=40529724604439"
      },
    
      "40535954161687": {
        variant_title: "couches (FSC Mix) + cotons",
        product_title: "Abonnement Joone",
        price: '70.80',
        sku: "JOONECHARGE.BUNDLE.CP.V1",
        product_type: "category_bb_hygiene",
        url: "/products/abonnement-couche?variant=40535954161687"
      },
    
      "40535954292759": {
        variant_title: "couches (FSC Mix) + cotons + lingettes + 1 soin",
        product_title: "Abonnement Joone",
        price: '85.70',
        sku: "JOONECHARGE.BUNDLE.CPLS.V1",
        product_type: "category_bb_hygiene",
        url: "/products/abonnement-couche?variant=40535954292759"
      },
    
      "40535954358295": {
        variant_title: "couches (FSC Mix)  + lingettes + 2 soins",
        product_title: "Abonnement Joone",
        price: '89.70',
        sku: "JOONECHARGE.BUNDLE.CLSS.V1",
        product_type: "category_bb_hygiene",
        url: "/products/abonnement-couche?variant=40535954358295"
      },
    
      "40535954423831": {
        variant_title: "couches-culottes (FSC Mix) + cotons",
        product_title: "Abonnement Joone",
        price: '70.80',
        sku: "JOONECHARGE.BUNDLE.CCP.V1",
        product_type: "category_bb_hygiene",
        url: "/products/abonnement-couche?variant=40535954423831"
      },
    
      "40535954587671": {
        variant_title: "couches-culottes (FSC Mix) + cotons + lingettes + 2 soins",
        product_title: "Abonnement Joone",
        price: '95.60',
        sku: "JOONECHARGE.BUNDLE.CCPLSS.V1",
        product_type: "category_bb_hygiene",
        url: "/products/abonnement-couche?variant=40535954587671"
      },
    
      "40535954685975": {
        variant_title: "mix couches & couches-culottes  (FSC Mix) + cotons",
        product_title: "Abonnement Joone",
        price: '70.80',
        sku: "JOONECHARGE.BUNDLE.CCP.C.V1",
        product_type: "category_bb_hygiene",
        url: "/products/abonnement-couche?variant=40535954685975"
      },
    
      "40901508366359": {
        variant_title: "couches + lingettes compostables",
        product_title: "Abonnement Joone",
        price: '69.90',
        sku: "JOONECHARGE.BUNDLE.CW.V1",
        product_type: "category_bb_hygiene",
        url: "/products/abonnement-couche?variant=40901508366359"
      },
    
      "40901508399127": {
        variant_title: "couches-culottes + lingettes compostables",
        product_title: "Abonnement Joone",
        price: '69.90',
        sku: "JOONECHARGE.BUNDLE.CCW.V1",
        product_type: "category_bb_hygiene",
        url: "/products/abonnement-couche?variant=40901508399127"
      },
    
      "40901508431895": {
        variant_title: "mix couches-culottes & couches + lingettes compostables",
        product_title: "Abonnement Joone",
        price: '69.90',
        sku: "JOONECHARGE.BUNDLE.CCW.C.V1",
        product_type: "category_bb_hygiene",
        url: "/products/abonnement-couche?variant=40901508431895"
      },
    
      "40901508464663": {
        variant_title: "couches + soin + lingettes compostables",
        product_title: "Abonnement Joone",
        price: '79.80',
        sku: "JOONECHARGE.BUNDLE.CWS.V1",
        product_type: "category_bb_hygiene",
        url: "/products/abonnement-couche?variant=40901508464663"
      },
    
      "40901508497431": {
        variant_title: "couches-culottes + soin + lingettes compostables",
        product_title: "Abonnement Joone",
        price: '79.80',
        sku: "JOONECHARGE.BUNDLE.CCWS.V1",
        product_type: "category_bb_hygiene",
        url: "/products/abonnement-couche?variant=40901508497431"
      },
    
      "40901508530199": {
        variant_title: "mix couches-culottes & couches + soin + lingettes compostables",
        product_title: "Abonnement Joone",
        price: '79.80',
        sku: "JOONECHARGE.BUNDLE.CCWS.C.V1",
        product_type: "category_bb_hygiene",
        url: "/products/abonnement-couche?variant=40901508530199"
      },
    
      "40901508562967": {
        variant_title: "couches + 2 soins + lingettes compostables",
        product_title: "Abonnement Joone",
        price: '89.70',
        sku: "JOONECHARGE.BUNDLE.CWSS.V1",
        product_type: "category_bb_hygiene",
        url: "/products/abonnement-couche?variant=40901508562967"
      },
    
      "40901508595735": {
        variant_title: "couches-culottes + 2 soins + lingettes compostables",
        product_title: "Abonnement Joone",
        price: '89.70',
        sku: "JOONECHARGE.BUNDLE.CCWSS.V1",
        product_type: "category_bb_hygiene",
        url: "/products/abonnement-couche?variant=40901508595735"
      },
    
      "40901508628503": {
        variant_title: "mix couches-culottes & couches + 2 soins + lingettes compostables",
        product_title: "Abonnement Joone",
        price: '89.70',
        sku: "JOONECHARGE.BUNDLE.CCWSS.C.V1",
        product_type: "category_bb_hygiene",
        url: "/products/abonnement-couche?variant=40901508628503"
      },
    
      "40901508661271": {
        variant_title: "couches + cotons + lingettes compostables",
        product_title: "Abonnement Joone",
        price: '75.80',
        sku: "JOONECHARGE.BUNDLE.CPW.V1",
        product_type: "category_bb_hygiene",
        url: "/products/abonnement-couche?variant=40901508661271"
      },
    
      "40901508694039": {
        variant_title: "couches-culottes + cotons + lingettes compostables",
        product_title: "Abonnement Joone",
        price: '75.80',
        sku: "JOONECHARGE.BUNDLE.CCPW.V1",
        product_type: "category_bb_hygiene",
        url: "/products/abonnement-couche?variant=40901508694039"
      },
    
      "40901508726807": {
        variant_title: "mix couches-culottes & couches + cotons + lingettes compostables",
        product_title: "Abonnement Joone",
        price: '75.80',
        sku: "JOONECHARGE.BUNDLE.CCPW.C.V1",
        product_type: "category_bb_hygiene",
        url: "/products/abonnement-couche?variant=40901508726807"
      },
    
      "40901508759575": {
        variant_title: "couches + cotons + soin + lingettes compostables",
        product_title: "Abonnement Joone",
        price: '85.70',
        sku: "JOONECHARGE.BUNDLE.CPWS.V1",
        product_type: "category_bb_hygiene",
        url: "/products/abonnement-couche?variant=40901508759575"
      },
    
      "40901508792343": {
        variant_title: "couches-culottes + cotons + soin + lingettes compostables",
        product_title: "Abonnement Joone",
        price: '85.70',
        sku: "JOONECHARGE.BUNDLE.CCPWS.V1",
        product_type: "category_bb_hygiene",
        url: "/products/abonnement-couche?variant=40901508792343"
      },
    
      "40901508825111": {
        variant_title: "mix couches-culottes & couches + cotons + soin + lingettes compostables",
        product_title: "Abonnement Joone",
        price: '85.70',
        sku: "JOONECHARGE.BUNDLE.CCPWS.C.V1",
        product_type: "category_bb_hygiene",
        url: "/products/abonnement-couche?variant=40901508825111"
      },
    
      "40901508857879": {
        variant_title: "couches + cotons + 2 soins + lingettes compostables",
        product_title: "Abonnement Joone",
        price: '95.60',
        sku: "JOONECHARGE.BUNDLE.CPWSS.V1",
        product_type: "category_bb_hygiene",
        url: "/products/abonnement-couche?variant=40901508857879"
      },
    
      "40901508890647": {
        variant_title: "couches-culottes + cotons + 2 soins + lingettes compostables",
        product_title: "Abonnement Joone",
        price: '95.60',
        sku: "JOONECHARGE.BUNDLE.CCPWSS.V1",
        product_type: "category_bb_hygiene",
        url: "/products/abonnement-couche?variant=40901508890647"
      },
    
      "40901508923415": {
        variant_title: "mix couches-culottes & couches + cotons + 2 soins + lingettes compostables",
        product_title: "Abonnement Joone",
        price: '95.60',
        sku: "JOONECHARGE.BUNDLE.CCPWSS.C.V1",
        product_type: "category_bb_hygiene",
        url: "/products/abonnement-couche?variant=40901508923415"
      },
    
  
    
      "31258602078231": {
        variant_title: "Default Title",
        product_title: "Boite Cloche Cosmetique Femme Enceinte",
        price: '0.00',
        sku: "BOI.CF.FM",
        product_type: "",
        url: "/products/boite-cloche-cosmetique-femme-enceinte?variant=31258602078231"
      },
    
  
    
      "30742948020247": {
        variant_title: "Tote bag rose vert",
        product_title: "Cadeau",
        price: '0.00',
        sku: "TOTE.VR",
        product_type: "BBtex",
        url: "/products/tote-bag-geste-commercial?variant=30742948020247"
      },
    
      "30244953391127": {
        variant_title: "Tote bag rose",
        product_title: "Cadeau",
        price: '0.00',
        sku: "TOTE.GC",
        product_type: "BBtex",
        url: "/products/tote-bag-geste-commercial?variant=30244953391127"
      },
    
  
    
      "39368726118423": {
        variant_title: "Stickers - Vert",
        product_title: "Cadeau",
        price: '0.00',
        sku: "PF.STICK.KIDGD.VERT",
        product_type: "",
        url: "/products/stickers-kids?variant=39368726118423"
      },
    
      "39368726151191": {
        variant_title: "Stickers - Orange",
        product_title: "Cadeau",
        price: '0.00',
        sku: "PF.STICK.KIDSPT.ORANG",
        product_type: "",
        url: "/products/stickers-kids?variant=39368726151191"
      },
    
  
    
      "39378398052375": {
        variant_title: "Pochette",
        product_title: "Cadeau",
        price: '0.00',
        sku: "POCH.FM",
        product_type: "",
        url: "/products/pochette-femme?variant=39378398052375"
      },
    
  
    
      "39910420709399": {
        variant_title: "Gourde JOONE x Gobi",
        product_title: "Cadeau - Gourde JOONE x Gobi",
        price: '0.00',
        sku: "PF.GOURDE.500ML",
        product_type: "",
        url: "/products/gourde-joone-x-gobi?variant=39910420709399"
      },
    
  
    
      "53505205404027": {
        variant_title: "Default Title",
        product_title: "Coffret Change",
        price: '22.90',
        sku: "CF.CHANG",
        product_type: "",
        url: "/products/coffret-change?variant=53505205404027"
      },
    
  
    
      "55221102215547": {
        variant_title: "38",
        product_title: "Culotte menstruelle moodz - Archives",
        price: '17.50',
        sku: "CUL.MENS.MOODZ.N.T38",
        product_type: "",
        url: "/products/culotte-menstruelle-moodz-archives?variant=55221102215547"
      },
    
      "55221102248315": {
        variant_title: "40",
        product_title: "Culotte menstruelle moodz - Archives",
        price: '17.50',
        sku: "CUL.MENS.MOODZ.N.T40",
        product_type: "",
        url: "/products/culotte-menstruelle-moodz-archives?variant=55221102248315"
      },
    
      "55221102281083": {
        variant_title: "42",
        product_title: "Culotte menstruelle moodz - Archives",
        price: '17.50',
        sku: "CUL.MENS.MOODZ.N.T42",
        product_type: "",
        url: "/products/culotte-menstruelle-moodz-archives?variant=55221102281083"
      },
    
      "55221102313851": {
        variant_title: "44",
        product_title: "Culotte menstruelle moodz - Archives",
        price: '17.50',
        sku: "CUL.MENS.MOODZ.N.T44",
        product_type: "",
        url: "/products/culotte-menstruelle-moodz-archives?variant=55221102313851"
      },
    
      "55221102182779": {
        variant_title: "36",
        product_title: "Culotte menstruelle moodz - Archives",
        price: '17.50',
        sku: "CUL.MENS.MOODZ.N.T36",
        product_type: "",
        url: "/products/culotte-menstruelle-moodz-archives?variant=55221102182779"
      },
    
  
    
      "53483570725243": {
        variant_title: "1 Déodorant Femme Fleur de Coton COSMOS ORGANIC",
        product_title: "Déodorant fleur de coton (COSMOS ORGANIC)",
        price: '10.90',
        sku: "DEO.FM.C.IDV",
        product_type: "category_wom_cosmetics",
        url: "/products/deodorant-bio-fleur-de-coton?variant=53483570725243"
      },
    
      "54983080804731": {
        variant_title: "2 Déodorants Femme Fleur de Coton COSMOS ORGANIC",
        product_title: "Déodorant fleur de coton (COSMOS ORGANIC)",
        price: '19.90',
        sku: "CF.DEO.FM.C.IDV",
        product_type: "category_wom_cosmetics",
        url: "/products/deodorant-bio-fleur-de-coton?variant=54983080804731"
      },
    
  
    
      "54983116783995": {
        variant_title: "1 Déodorant Femme Pêche COSMOS ORGANIC",
        product_title: "Déodorant pêche blanche (COSMOS ORGANIC)",
        price: '10.90',
        sku: "DEO.FM.P.IDV",
        product_type: "category_wom_cosmetics",
        url: "/products/deodorant-bio-peche?variant=54983116783995"
      },
    
      "54983116816763": {
        variant_title: "2 Déodorants Femme Pêche COSMOS ORGANIC",
        product_title: "Déodorant pêche blanche (COSMOS ORGANIC)",
        price: '19.90',
        sku: "CF.DEO.FM.P.IDV",
        product_type: "category_wom_cosmetics",
        url: "/products/deodorant-bio-peche?variant=54983116816763"
      },
    
  
    
      "54983120978299": {
        variant_title: "Default Title",
        product_title: "Duo de déodorants pêche et fleur de coton (COSMOS ORGANIC)",
        price: '19.90',
        sku: "CF.DEO.FM.DUO.IDV",
        product_type: "category_wom_cosmetics",
        url: "/products/duo-deodorants-bio-peche-fleur-de-coton?variant=54983120978299"
      },
    
  
    
      "39364840259607": {
        variant_title: "Couches FSC Mix* / T1",
        product_title: "Echantillons 2 couches / 2 couches-culottes FSC Mix*",
        price: '0.00',
        sku: "ECH.2C.T1",
        product_type: "",
        url: "/products/echantillons-2-couches-2-couches-culottes?variant=39364840259607"
      },
    
      "39364840292375": {
        variant_title: "Couches FSC Mix* / T2",
        product_title: "Echantillons 2 couches / 2 couches-culottes FSC Mix*",
        price: '0.00',
        sku: "ECH.2C.T2",
        product_type: "",
        url: "/products/echantillons-2-couches-2-couches-culottes?variant=39364840292375"
      },
    
      "39364840325143": {
        variant_title: "Couches FSC Mix* / T3",
        product_title: "Echantillons 2 couches / 2 couches-culottes FSC Mix*",
        price: '0.00',
        sku: "ECH.2C.T3",
        product_type: "",
        url: "/products/echantillons-2-couches-2-couches-culottes?variant=39364840325143"
      },
    
      "39364840357911": {
        variant_title: "Couches FSC Mix* / T4",
        product_title: "Echantillons 2 couches / 2 couches-culottes FSC Mix*",
        price: '0.00',
        sku: "ECH.2C.T4",
        product_type: "",
        url: "/products/echantillons-2-couches-2-couches-culottes?variant=39364840357911"
      },
    
      "39364840390679": {
        variant_title: "Couches FSC Mix* / T5",
        product_title: "Echantillons 2 couches / 2 couches-culottes FSC Mix*",
        price: '0.00',
        sku: "ECH.2C.T5",
        product_type: "",
        url: "/products/echantillons-2-couches-2-couches-culottes?variant=39364840390679"
      },
    
      "39364840423447": {
        variant_title: "Couches FSC Mix* / T6",
        product_title: "Echantillons 2 couches / 2 couches-culottes FSC Mix*",
        price: '0.00',
        sku: "ECH.2C.T6",
        product_type: "",
        url: "/products/echantillons-2-couches-2-couches-culottes?variant=39364840423447"
      },
    
      "39364840554519": {
        variant_title: "Couche-Culottes FSC Mix* / T4",
        product_title: "Echantillons 2 couches / 2 couches-culottes FSC Mix*",
        price: '0.00',
        sku: "ECH.2CC2.T4",
        product_type: "",
        url: "/products/echantillons-2-couches-2-couches-culottes?variant=39364840554519"
      },
    
      "39364840587287": {
        variant_title: "Couche-Culottes FSC Mix* / T5",
        product_title: "Echantillons 2 couches / 2 couches-culottes FSC Mix*",
        price: '0.00',
        sku: "ECH.2CC2.T5",
        product_type: "",
        url: "/products/echantillons-2-couches-2-couches-culottes?variant=39364840587287"
      },
    
      "39364840620055": {
        variant_title: "Couche-Culottes FSC Mix* / T6",
        product_title: "Echantillons 2 couches / 2 couches-culottes FSC Mix*",
        price: '0.00',
        sku: "ECH.2CC2.T6",
        product_type: "",
        url: "/products/echantillons-2-couches-2-couches-culottes?variant=39364840620055"
      },
    
  
    
      "32963122495511": {
        variant_title: "Flyer taille au dessus couche seul",
        product_title: "Flyer",
        price: '0.00',
        sku: "FL.SUP.COUCH",
        product_type: "category_freebie",
        url: "/products/flyer?variant=32963122495511"
      },
    
      "32963122528279": {
        variant_title: "Flyer taille au dessus couche + pants",
        product_title: "Flyer",
        price: '0.00',
        sku: "FL.SUP.COUCH.PANTS",
        product_type: "category_freebie",
        url: "/products/flyer?variant=32963122528279"
      },
    
      "32963122561047": {
        variant_title: "Flyer Blissim",
        product_title: "Flyer",
        price: '0.00',
        sku: "FL.BLISSIM",
        product_type: "category_freebie",
        url: "/products/flyer?variant=32963122561047"
      },
    
      "33016717836311": {
        variant_title: "Flyer Coffret Découverte",
        product_title: "Flyer",
        price: '0.00',
        sku: "FL.OP.CF.DEC",
        product_type: "category_freebie",
        url: "/products/flyer?variant=33016717836311"
      },
    
      "33021632413719": {
        variant_title: "Flyer Coffret Maternité",
        product_title: "Flyer",
        price: '0.00',
        sku: "FL.OP.CF.MAT",
        product_type: "category_freebie",
        url: "/products/flyer?variant=33021632413719"
      },
    
      "39292398206999": {
        variant_title: "Flyer Mélanie Johnsson",
        product_title: "Flyer",
        price: '0.00',
        sku: "FL.WE.TAKE.CARE",
        product_type: "category_freebie",
        url: "/products/flyer?variant=39292398206999"
      },
    
      "33042967920663": {
        variant_title: "Flyer serviette hygiénique",
        product_title: "Flyer",
        price: '0.00',
        sku: "FL.SERV.HYG",
        product_type: "category_freebie",
        url: "/products/flyer?variant=33042967920663"
      },
    
      "39290132529175": {
        variant_title: "Flyer Lovevery",
        product_title: "Flyer",
        price: '0.00',
        sku: "FL.LOVEVERY",
        product_type: "category_freebie",
        url: "/products/flyer?variant=39290132529175"
      },
    
      "39391748423703": {
        variant_title: "Flyer dentifrice",
        product_title: "Flyer",
        price: '0.00',
        sku: "FL.DENT.ENF",
        product_type: "category_freebie",
        url: "/products/flyer?variant=39391748423703"
      },
    
  
    
      "55257786941819": {
        variant_title: "Paris",
        product_title: "Joone Paris & MAMA",
        price: '0.00',
        sku: "SAC.JOONE.PARIS",
        product_type: "",
        url: "/products/joone-paris-mama?variant=55257786941819"
      },
    
      "55257786974587": {
        variant_title: "Mama",
        product_title: "Joone Paris & MAMA",
        price: '0.00',
        sku: "SAC.JOONE.MAMA",
        product_type: "",
        url: "/products/joone-paris-mama?variant=55257786974587"
      },
    
  
    
      "40339616202775": {
        variant_title: "Default Title",
        product_title: "L' eau de senteur",
        price: '10.47',
        sku: "EAU.SENTEUR",
        product_type: "category_bb_cosmetics",
        url: "/products/leau-de-senteur?variant=40339616202775"
      },
    
  
    
      "39290246496279": {
        variant_title: "Default Title",
        product_title: "l'affiche solidaire JOONE x Mélanie Johnsson",
        price: '20.00',
        sku: "TUBE.WE.TAKE.CARE",
        product_type: "",
        url: "/products/affiche-melanie-johnsson?variant=39290246496279"
      },
    
  
    
      "41609536864279": {
        variant_title: "Default Title",
        product_title: "L'eau micellaire 100ML - COSMOS ORGANIC",
        price: '4.90',
        sku: "EM2.100.IDV",
        product_type: "category_bb_cosmetics",
        url: "/products/le-liniment-100ml-1?variant=41609536864279"
      },
    
  
    
      "40827841019927": {
        variant_title: "Default Title",
        product_title: "L'eau micellaire 400ML - Archives (COSMOS ORGANIC)",
        price: '12.53',
        sku: "EM.OUT",
        product_type: "",
        url: "/products/leau-micellaire-400ml-archives?variant=40827841019927"
      },
    
  
    
      "40180877262871": {
        variant_title: "L'eau nettoyante 400 ml",
        product_title: "l'eau nettoyante (COSMOS ORGANIC)",
        price: '11.90',
        sku: "EM4.IDV",
        product_type: "category_bb_cosmetics",
        url: "/products/eau-micellaire?variant=40180877262871"
      },
    
  
    
      "33021656989719": {
        variant_title: "Default Title",
        product_title: "l'huile de massage (COSMOS ORGANIC)",
        price: '10.90',
        sku: "HUIL.MASS.IDV",
        product_type: "category_bb_cosmetics",
        url: "/products/huile-de-massage-bebe?variant=33021656989719"
      },
    
  
    
      "40864506675223": {
        variant_title: "Default Title",
        product_title: "L'huile de massage - Archives (COSMOS ORGANIC)",
        price: '5.45',
        sku: "HUIL.MASS",
        product_type: "category_bb_cosmetics",
        url: "/products/lhuile-de-massage-archives?variant=40864506675223"
      },
    
  
    
      "29385592078359": {
        variant_title: "Default Title",
        product_title: "L'huile vergetures (COSMOS ORGANIC)",
        price: '29.90',
        sku: "ENC.HV.IDV",
        product_type: "category_wom_cosmetics",
        url: "/products/lhuile-vergetures-parfaite?variant=29385592078359"
      },
    
  
    
      "31271946649623": {
        variant_title: "Odette",
        product_title: "la cape de bain",
        price: '27.96',
        sku: "SDB.P",
        product_type: "category_bb_textile",
        url: "/products/cape-de-bain-bebe?variant=31271946649623"
      },
    
      "31271946584087": {
        variant_title: "Brigitte",
        product_title: "la cape de bain",
        price: '27.96',
        sku: "SDB.RC",
        product_type: "category_bb_textile",
        url: "/products/cape-de-bain-bebe?variant=31271946584087"
      },
    
      "29308240822295": {
        variant_title: "Malo",
        product_title: "la cape de bain",
        price: '27.96',
        sku: "SDB.ML",
        product_type: "category_bb_textile",
        url: "/products/cape-de-bain-bebe?variant=29308240822295"
      },
    
      "29308246425623": {
        variant_title: "Leon",
        product_title: "la cape de bain",
        price: '27.96',
        sku: "SDB.LE",
        product_type: "category_bb_textile",
        url: "/products/cape-de-bain-bebe?variant=29308246425623"
      },
    
      "31145068986391": {
        variant_title: "Bernard",
        product_title: "la cape de bain",
        price: '27.96',
        sku: "SDB.BE",
        product_type: "category_bb_textile",
        url: "/products/cape-de-bain-bebe?variant=31145068986391"
      },
    
  
    
      "40284968124439": {
        variant_title: "T1 (2 à 4kg) - 30 COUCHES FSC Mix*",
        product_title: "La couche ORIGINE sans abonnement (FSC Mix*)",
        price: '13.50',
        sku: "S.SING.GREEN.PE.T1.OO",
        product_type: "category_bb_cosmetics",
        url: "/products/couches-origine-one-off?variant=40284968124439"
      },
    
      "40284968222743": {
        variant_title: "T2 (3 à 5kg) - 32 COUCHES FSC Mix*",
        product_title: "La couche ORIGINE sans abonnement (FSC Mix*)",
        price: '13.50',
        sku: "S.SING.GREEN.PE.T2.OO",
        product_type: "category_bb_cosmetics",
        url: "/products/couches-origine-one-off?variant=40284968222743"
      },
    
      "40284968321047": {
        variant_title: "T3 (4 à 8kg) - 27 COUCHES FSC Mix*",
        product_title: "La couche ORIGINE sans abonnement (FSC Mix*)",
        price: '13.50',
        sku: "S.SING.GREEN.PE.T3.OO",
        product_type: "category_bb_cosmetics",
        url: "/products/couches-origine-one-off?variant=40284968321047"
      },
    
      "40284968419351": {
        variant_title: "T4 (7 à 14kg) - 24 COUCHES FSC Mix*",
        product_title: "La couche ORIGINE sans abonnement (FSC Mix*)",
        price: '13.50',
        sku: "S.SING.GREEN.PE.T4.OO",
        product_type: "category_bb_cosmetics",
        url: "/products/couches-origine-one-off?variant=40284968419351"
      },
    
      "40284968517655": {
        variant_title: "T5 (10 à 18kg) - 20 COUCHES FSC Mix*",
        product_title: "La couche ORIGINE sans abonnement (FSC Mix*)",
        price: '13.50',
        sku: "S.SING.GREEN.PE.T5.OO",
        product_type: "category_bb_cosmetics",
        url: "/products/couches-origine-one-off?variant=40284968517655"
      },
    
      "40284968615959": {
        variant_title: "T6 (16 à 30kg) - 19 COUCHES FSC Mix*",
        product_title: "La couche ORIGINE sans abonnement (FSC Mix*)",
        price: '13.50',
        sku: "S.SING.GREEN.PE.T6.OO",
        product_type: "category_bb_cosmetics",
        url: "/products/couches-origine-one-off?variant=40284968615959"
      },
    
  
    
      "40339653591063": {
        variant_title: "Default Title",
        product_title: "La couche prématuré (FSC Mix*)",
        price: '9.90',
        sku: "S.BL.PE.T0",
        product_type: "category_bb_cosmetics",
        url: "/products/la-couche-taille-0?variant=40339653591063"
      },
    
  
    
      "40143087894551": {
        variant_title: "T4 (8 à 14 kg) - 30 couches-culottes FSC Mix* / Malo",
        product_title: "La couche-culotte sans abonnement",
        price: '16.90',
        sku: "S.SING.CC.ML.T4.OO",
        product_type: "category_bb_cosmetics",
        url: "/products/paquet-de-couche-culotte?variant=40143087894551"
      },
    
      "40143087927319": {
        variant_title: "T4 (8 à 14 kg) - 30 couches-culottes FSC Mix* / Brigitte",
        product_title: "La couche-culotte sans abonnement",
        price: '16.90',
        sku: "S.SING.CC.RC.T4.OO",
        product_type: "category_bb_cosmetics",
        url: "/products/paquet-de-couche-culotte?variant=40143087927319"
      },
    
      "40143087960087": {
        variant_title: "T5 (12 à 18 kg) - 28 couches-culottes FSC Mix* / Malo",
        product_title: "La couche-culotte sans abonnement",
        price: '16.90',
        sku: "S.SING.CC.ML.T5.OO",
        product_type: "category_bb_cosmetics",
        url: "/products/paquet-de-couche-culotte?variant=40143087960087"
      },
    
      "40143087992855": {
        variant_title: "T5 (12 à 18 kg) - 28 couches-culottes FSC Mix* / Brigitte",
        product_title: "La couche-culotte sans abonnement",
        price: '16.90',
        sku: "S.SING.CC.RC.T5.OO",
        product_type: "category_bb_cosmetics",
        url: "/products/paquet-de-couche-culotte?variant=40143087992855"
      },
    
      "40143088025623": {
        variant_title: "T6 (16 à 30 kg) - 26 couches-culottes FSC Mix* / Malo",
        product_title: "La couche-culotte sans abonnement",
        price: '16.90',
        sku: "S.SING.CC.ML.T6.OO",
        product_type: "category_bb_cosmetics",
        url: "/products/paquet-de-couche-culotte?variant=40143088025623"
      },
    
      "40143088058391": {
        variant_title: "T6 (16 à 30 kg) - 26 couches-culottes FSC Mix* / Brigitte",
        product_title: "La couche-culotte sans abonnement",
        price: '16.90',
        sku: "S.SING.CC.RC.T6.OO",
        product_type: "category_bb_cosmetics",
        url: "/products/paquet-de-couche-culotte?variant=40143088058391"
      },
    
  
    
      "39293783080983": {
        variant_title: "la crème de change (7ml)",
        product_title: "la crème de change (7ml)",
        price: '0.00',
        sku: "ECH.CRM.CHANG",
        product_type: "",
        url: "/products/miniature-7ml-creme-de-change?variant=39293783080983"
      },
    
  
    
      "39259159920663": {
        variant_title: "Default Title",
        product_title: "la crème de change (COSMOS ORGANIC)",
        price: '8.90',
        sku: "CRM.CHANG.IDV",
        product_type: "category_bb_cosmetics",
        url: "/products/creme-de-change-bebe?variant=39259159920663"
      },
    
  
    
      "40960125894679": {
        variant_title: "Default Title",
        product_title: "La crème hydratante SPF 50+",
        price: '21.90',
        sku: "CRM.VIS.SPF",
        product_type: "category_wom_cosmetics",
        url: "/products/creme-hydratante-spf-50?variant=40960125894679"
      },
    
  
    
      "41169802690583": {
        variant_title: "Avec cartelette",
        product_title: "La crème hydratante SPF50+ (2ml)",
        price: '0.00',
        sku: "ECH.CRM.VIS.SPF.CART",
        product_type: "",
        url: "/products/echantillon-creme-visage-spf?variant=41169802690583"
      },
    
      "41169802723351": {
        variant_title: "Sans cartelette",
        product_title: "La crème hydratante SPF50+ (2ml)",
        price: '0.00',
        sku: "ECH.CRM.VIS.SPF",
        product_type: "",
        url: "/products/echantillon-creme-visage-spf?variant=41169802723351"
      },
    
  
    
      "40338273304599": {
        variant_title: "Default Title",
        product_title: "la crème lavante surgras (COSMOS ORGANIC)",
        price: '12.90',
        sku: "CRM.LAV.SURG",
        product_type: "category_bb_cosmetics",
        url: "/products/la-creme-lavante?variant=40338273304599"
      },
    
  
    
      "39421802086423": {
        variant_title: "la crème vergeture (7ml)",
        product_title: "La crème vergetures (7ml) - COSMOS ORGANIC",
        price: '0.00',
        sku: "ECH.ENC.CV",
        product_type: "",
        url: "/products/echantillon-creme-vergeture?variant=39421802086423"
      },
    
  
    
      "40577761771543": {
        variant_title: "200 ml - Crème vergetures COSMOS ORGANIC",
        product_title: "La crème vergetures (COSMOS ORGANIC)",
        price: '27.90',
        sku: "ENC.CV.IDV",
        product_type: "category_wom_cosmetics",
        url: "/products/creme-vergeture?variant=40577761771543"
      },
    
      "40577761804311": {
        variant_title: "50 ml - Crème vergetures COSMOS ORGANIC",
        product_title: "La crème vergetures (COSMOS ORGANIC)",
        price: '7.90',
        sku: "ENC.CV.50",
        product_type: "category_wom_cosmetics",
        url: "/products/creme-vergeture?variant=40577761804311"
      },
    
  
    
      "39259161853975": {
        variant_title: "Default Title",
        product_title: "la crème visage bébé (COSMOS ORGANIC)",
        price: '7.90',
        sku: "CRM.VISAG.IDV",
        product_type: "category_bb_cosmetics",
        url: "/products/creme-visage-bebe?variant=39259161853975"
      },
    
  
    
      "39379906199575": {
        variant_title: "la crème visage enfant (2 ml) - COSMOS ORGANIC",
        product_title: "la crème visage enfant (2 ml)",
        price: '0.00',
        sku: "ECH.ENF.CRM.VIS",
        product_type: "",
        url: "/products/sachet-creme-visage-enfant-2-ml?variant=39379906199575"
      },
    
  
    
      "39870414094359": {
        variant_title: "la gelée démaquillante (15 ml)",
        product_title: "la gelée démaquillante miniature (COSMOS ORGANIC)",
        price: '0.00',
        sku: "GELEE.DMA.15.IDV",
        product_type: "",
        url: "/products/la-gelee-demaquillante-parfaite-miniature-15-ml?variant=39870414094359"
      },
    
  
    
      "39301442338839": {
        variant_title: "Default Title",
        product_title: "La gourde JOONE x Gobi",
        price: '11.96',
        sku: "PF.GOURDE1.500ML",
        product_type: "category_wom_cosmetics",
        url: "/products/gourde-joone-500-ml?variant=39301442338839"
      },
    
  
    
      "39394103590935": {
        variant_title: "la petite pochette cadeau",
        product_title: "la pochette cadeau de Noël",
        price: '0.00',
        sku: "POCHETTE.NOEL.PT",
        product_type: "",
        url: "/products/pochettes-cadeau-noel-2021?variant=39394103590935"
      },
    
      "39394103623703": {
        variant_title: "la grande pochette cadeau",
        product_title: "la pochette cadeau de Noël",
        price: '0.00',
        sku: "POCHETTE.NOEL.GD",
        product_type: "",
        url: "/products/pochettes-cadeau-noel-2021?variant=39394103623703"
      },
    
  
    
      "39861505785879": {
        variant_title: "100 ml",
        product_title: "la trousse de voyage (COSMOS ORGANIC et NATURAL)",
        price: '24.90',
        sku: "TRAV.L1E.50",
        product_type: "category_bb_cosmetics",
        url: "/products/trousse-de-voyage-bebe?variant=39861505785879"
      },
    
      "54928891576699": {
        variant_title: "50 ml",
        product_title: "la trousse de voyage (COSMOS ORGANIC et NATURAL)",
        price: '19.90',
        sku: "TRAV.MINI.L1E.50",
        product_type: "category_bb_cosmetics",
        url: "/products/trousse-de-voyage-bebe?variant=54928891576699"
      },
    
  
    
      "39405310902295": {
        variant_title: "Biberon dinosaure",
        product_title: "le biberon JOONE x Le Biberon Français",
        price: '7.47',
        sku: "BIBERON.DINO-1",
        product_type: "category_bb_textile",
        url: "/products/biberon-dinosaure?variant=39405310902295"
      },
    
  
    
      "31656789606423": {
        variant_title: "3 mois - (60cm) / Body individuel Manches Courtes - (Imprimé) / Odette",
        product_title: "le body manches courtes",
        price: '9.96',
        sku: "BODY3M.P.MC",
        product_type: "category_bb_textile",
        url: "/products/le-body-manche-courtes?variant=31656789606423"
      },
    
      "31656789639191": {
        variant_title: "3 mois - (60cm) / Body individuel Manches Courtes - (Patch) / Odette",
        product_title: "le body manches courtes",
        price: '9.96',
        sku: "BODYP3M.P.MC",
        product_type: "category_bb_textile",
        url: "/products/le-body-manche-courtes?variant=31656789639191"
      },
    
      "31656789671959": {
        variant_title: "3 mois - (60cm) / Duo de bodies Manches Courtes - (Patch et Imprimé) / Odette",
        product_title: "le body manches courtes",
        price: '19.92',
        sku: "BODIES3M.P.MC",
        product_type: "category_bb_textile",
        url: "/products/le-body-manche-courtes?variant=31656789671959"
      },
    
      "31656789704727": {
        variant_title: "3 mois - (60cm) / Body individuel Manches Courtes - (Imprimé) / Brigitte",
        product_title: "le body manches courtes",
        price: '9.96',
        sku: "BODY3M.RC.MC",
        product_type: "category_bb_textile",
        url: "/products/le-body-manche-courtes?variant=31656789704727"
      },
    
      "31656789737495": {
        variant_title: "3 mois - (60cm) / Body individuel Manches Courtes - (Patch) / Brigitte",
        product_title: "le body manches courtes",
        price: '9.96',
        sku: "BODYP3M.RC.MC",
        product_type: "category_bb_textile",
        url: "/products/le-body-manche-courtes?variant=31656789737495"
      },
    
      "31656789770263": {
        variant_title: "3 mois - (60cm) / Duo de bodies Manches Courtes - (Patch et Imprimé) / Brigitte",
        product_title: "le body manches courtes",
        price: '19.92',
        sku: "BODIES3M.RC.MC",
        product_type: "category_bb_textile",
        url: "/products/le-body-manche-courtes?variant=31656789770263"
      },
    
      "31656789803031": {
        variant_title: "3 mois - (60cm) / Body individuel Manches Courtes - (Imprimé) / Malo",
        product_title: "le body manches courtes",
        price: '9.96',
        sku: "BODY3M.ML.MC",
        product_type: "category_bb_textile",
        url: "/products/le-body-manche-courtes?variant=31656789803031"
      },
    
      "31656789835799": {
        variant_title: "3 mois - (60cm) / Body individuel Manches Courtes - (Patch) / Malo",
        product_title: "le body manches courtes",
        price: '9.96',
        sku: "BODYP3M.ML.MC",
        product_type: "category_bb_textile",
        url: "/products/le-body-manche-courtes?variant=31656789835799"
      },
    
      "31656789868567": {
        variant_title: "3 mois - (60cm) / Duo de bodies Manches Courtes - (Patch et Imprimé) / Malo",
        product_title: "le body manches courtes",
        price: '19.92',
        sku: "BODIES3M.ML.MC",
        product_type: "category_bb_textile",
        url: "/products/le-body-manche-courtes?variant=31656789868567"
      },
    
      "31656790097943": {
        variant_title: "6 mois - (67cm) / Body individuel Manches Courtes - (Imprimé) / Odette",
        product_title: "le body manches courtes",
        price: '9.96',
        sku: "BODY6M.P.MC",
        product_type: "category_bb_textile",
        url: "/products/le-body-manche-courtes?variant=31656790097943"
      },
    
      "31656790130711": {
        variant_title: "6 mois - (67cm) / Body individuel Manches Courtes - (Patch) / Odette",
        product_title: "le body manches courtes",
        price: '9.96',
        sku: "BODYP6M.P.MC",
        product_type: "category_bb_textile",
        url: "/products/le-body-manche-courtes?variant=31656790130711"
      },
    
      "31656790163479": {
        variant_title: "6 mois - (67cm) / Duo de bodies Manches Courtes - (Patch et Imprimé) / Odette",
        product_title: "le body manches courtes",
        price: '19.92',
        sku: "BODIES6M.P.MC",
        product_type: "category_bb_textile",
        url: "/products/le-body-manche-courtes?variant=31656790163479"
      },
    
      "31656790196247": {
        variant_title: "6 mois - (67cm) / Body individuel Manches Courtes - (Imprimé) / Brigitte",
        product_title: "le body manches courtes",
        price: '9.96',
        sku: "BODY6M.RC.MC",
        product_type: "category_bb_textile",
        url: "/products/le-body-manche-courtes?variant=31656790196247"
      },
    
      "31656790229015": {
        variant_title: "6 mois - (67cm) / Body individuel Manches Courtes - (Patch) / Brigitte",
        product_title: "le body manches courtes",
        price: '9.96',
        sku: "BODYP6M.RC.MC",
        product_type: "category_bb_textile",
        url: "/products/le-body-manche-courtes?variant=31656790229015"
      },
    
      "31656790261783": {
        variant_title: "6 mois - (67cm) / Duo de bodies Manches Courtes - (Patch et Imprimé) / Brigitte",
        product_title: "le body manches courtes",
        price: '19.92',
        sku: "BODIES6M.RC.MC",
        product_type: "category_bb_textile",
        url: "/products/le-body-manche-courtes?variant=31656790261783"
      },
    
      "31656790294551": {
        variant_title: "6 mois - (67cm) / Body individuel Manches Courtes - (Imprimé) / Malo",
        product_title: "le body manches courtes",
        price: '9.96',
        sku: "BODY6M.ML.MC",
        product_type: "category_bb_textile",
        url: "/products/le-body-manche-courtes?variant=31656790294551"
      },
    
      "31656790327319": {
        variant_title: "6 mois - (67cm) / Body individuel Manches Courtes - (Patch) / Malo",
        product_title: "le body manches courtes",
        price: '9.96',
        sku: "BODYP6M.ML.MC",
        product_type: "category_bb_textile",
        url: "/products/le-body-manche-courtes?variant=31656790327319"
      },
    
      "31656790360087": {
        variant_title: "6 mois - (67cm) / Duo de bodies Manches Courtes - (Patch et Imprimé) / Malo",
        product_title: "le body manches courtes",
        price: '19.92',
        sku: "BODIES6M.ML.MC",
        product_type: "category_bb_textile",
        url: "/products/le-body-manche-courtes?variant=31656790360087"
      },
    
      "31656790589463": {
        variant_title: "9 mois - (71 cm) / Body individuel Manches Courtes - (Imprimé) / Odette",
        product_title: "le body manches courtes",
        price: '9.96',
        sku: "BODY9M.P.MC",
        product_type: "category_bb_textile",
        url: "/products/le-body-manche-courtes?variant=31656790589463"
      },
    
      "31656790622231": {
        variant_title: "9 mois - (71 cm) / Body individuel Manches Courtes - (Patch) / Odette",
        product_title: "le body manches courtes",
        price: '9.96',
        sku: "BODYP9M.P.MC",
        product_type: "category_bb_textile",
        url: "/products/le-body-manche-courtes?variant=31656790622231"
      },
    
      "31656790654999": {
        variant_title: "9 mois - (71 cm) / Duo de bodies Manches Courtes - (Patch et Imprimé) / Odette",
        product_title: "le body manches courtes",
        price: '19.92',
        sku: "BODIES9M.P.MC",
        product_type: "category_bb_textile",
        url: "/products/le-body-manche-courtes?variant=31656790654999"
      },
    
      "31656790687767": {
        variant_title: "9 mois - (71 cm) / Body individuel Manches Courtes - (Imprimé) / Brigitte",
        product_title: "le body manches courtes",
        price: '9.96',
        sku: "BODY9M.RC.MC",
        product_type: "category_bb_textile",
        url: "/products/le-body-manche-courtes?variant=31656790687767"
      },
    
      "31656790720535": {
        variant_title: "9 mois - (71 cm) / Body individuel Manches Courtes - (Patch) / Brigitte",
        product_title: "le body manches courtes",
        price: '9.96',
        sku: "BODYP9M.RC.MC",
        product_type: "category_bb_textile",
        url: "/products/le-body-manche-courtes?variant=31656790720535"
      },
    
      "31656790753303": {
        variant_title: "9 mois - (71 cm) / Duo de bodies Manches Courtes - (Patch et Imprimé) / Brigitte",
        product_title: "le body manches courtes",
        price: '19.92',
        sku: "BODIES9M.RC.MC",
        product_type: "category_bb_textile",
        url: "/products/le-body-manche-courtes?variant=31656790753303"
      },
    
      "31656790786071": {
        variant_title: "9 mois - (71 cm) / Body individuel Manches Courtes - (Imprimé) / Malo",
        product_title: "le body manches courtes",
        price: '9.96',
        sku: "BODY9M.ML.MC",
        product_type: "category_bb_textile",
        url: "/products/le-body-manche-courtes?variant=31656790786071"
      },
    
      "31656790818839": {
        variant_title: "9 mois - (71 cm) / Body individuel Manches Courtes - (Patch) / Malo",
        product_title: "le body manches courtes",
        price: '9.96',
        sku: "BODYP9M.ML.MC",
        product_type: "category_bb_textile",
        url: "/products/le-body-manche-courtes?variant=31656790818839"
      },
    
      "31656790851607": {
        variant_title: "9 mois - (71 cm) / Duo de bodies Manches Courtes - (Patch et Imprimé) / Malo",
        product_title: "le body manches courtes",
        price: '19.92',
        sku: "BODIES9M.ML.MC",
        product_type: "category_bb_textile",
        url: "/products/le-body-manche-courtes?variant=31656790851607"
      },
    
      "31656791080983": {
        variant_title: "12 mois - (74 cm) / Body individuel Manches Courtes - (Imprimé) / Odette",
        product_title: "le body manches courtes",
        price: '9.96',
        sku: "BODY12M.P.MC",
        product_type: "category_bb_textile",
        url: "/products/le-body-manche-courtes?variant=31656791080983"
      },
    
      "31656791113751": {
        variant_title: "12 mois - (74 cm) / Body individuel Manches Courtes - (Patch) / Odette",
        product_title: "le body manches courtes",
        price: '9.96',
        sku: "BODYP12M.P.MC",
        product_type: "category_bb_textile",
        url: "/products/le-body-manche-courtes?variant=31656791113751"
      },
    
      "31656791146519": {
        variant_title: "12 mois - (74 cm) / Duo de bodies Manches Courtes - (Patch et Imprimé) / Odette",
        product_title: "le body manches courtes",
        price: '19.92',
        sku: "BODIES12M.P.MC",
        product_type: "category_bb_textile",
        url: "/products/le-body-manche-courtes?variant=31656791146519"
      },
    
      "31656791179287": {
        variant_title: "12 mois - (74 cm) / Body individuel Manches Courtes - (Imprimé) / Brigitte",
        product_title: "le body manches courtes",
        price: '9.96',
        sku: "BODY12M.RC.MC",
        product_type: "category_bb_textile",
        url: "/products/le-body-manche-courtes?variant=31656791179287"
      },
    
      "31656791212055": {
        variant_title: "12 mois - (74 cm) / Body individuel Manches Courtes - (Patch) / Brigitte",
        product_title: "le body manches courtes",
        price: '9.96',
        sku: "BODYP12M.RC.MC",
        product_type: "category_bb_textile",
        url: "/products/le-body-manche-courtes?variant=31656791212055"
      },
    
      "31656791244823": {
        variant_title: "12 mois - (74 cm) / Duo de bodies Manches Courtes - (Patch et Imprimé) / Brigitte",
        product_title: "le body manches courtes",
        price: '19.92',
        sku: "BODIES12M.RC.MC",
        product_type: "category_bb_textile",
        url: "/products/le-body-manche-courtes?variant=31656791244823"
      },
    
      "31656791277591": {
        variant_title: "12 mois - (74 cm) / Body individuel Manches Courtes - (Imprimé) / Malo",
        product_title: "le body manches courtes",
        price: '9.96',
        sku: "BODY12M.ML.MC",
        product_type: "category_bb_textile",
        url: "/products/le-body-manche-courtes?variant=31656791277591"
      },
    
      "31656791310359": {
        variant_title: "12 mois - (74 cm) / Body individuel Manches Courtes - (Patch) / Malo",
        product_title: "le body manches courtes",
        price: '9.96',
        sku: "BODYP12M.ML.MC",
        product_type: "category_bb_textile",
        url: "/products/le-body-manche-courtes?variant=31656791310359"
      },
    
      "31656791343127": {
        variant_title: "12 mois - (74 cm) / Duo de bodies Manches Courtes - (Patch et Imprimé) / Malo",
        product_title: "le body manches courtes",
        price: '19.92',
        sku: "BODIES12M.ML.MC",
        product_type: "category_bb_textile",
        url: "/products/le-body-manche-courtes?variant=31656791343127"
      },
    
      "31656791572503": {
        variant_title: "18 mois - (81 cm) / Body individuel Manches Courtes - (Imprimé) / Odette",
        product_title: "le body manches courtes",
        price: '9.96',
        sku: "BODY18M.P.MC",
        product_type: "category_bb_textile",
        url: "/products/le-body-manche-courtes?variant=31656791572503"
      },
    
      "31656791605271": {
        variant_title: "18 mois - (81 cm) / Body individuel Manches Courtes - (Patch) / Odette",
        product_title: "le body manches courtes",
        price: '9.96',
        sku: "BODYP18M.P.MC",
        product_type: "category_bb_textile",
        url: "/products/le-body-manche-courtes?variant=31656791605271"
      },
    
      "31656791638039": {
        variant_title: "18 mois - (81 cm) / Duo de bodies Manches Courtes - (Patch et Imprimé) / Odette",
        product_title: "le body manches courtes",
        price: '19.92',
        sku: "BODIES18M.P.MC",
        product_type: "category_bb_textile",
        url: "/products/le-body-manche-courtes?variant=31656791638039"
      },
    
      "31656791670807": {
        variant_title: "18 mois - (81 cm) / Body individuel Manches Courtes - (Imprimé) / Brigitte",
        product_title: "le body manches courtes",
        price: '9.96',
        sku: "BODY18M.RC.MC",
        product_type: "category_bb_textile",
        url: "/products/le-body-manche-courtes?variant=31656791670807"
      },
    
      "31656791703575": {
        variant_title: "18 mois - (81 cm) / Body individuel Manches Courtes - (Patch) / Brigitte",
        product_title: "le body manches courtes",
        price: '9.96',
        sku: "BODYP18M.RC.MC",
        product_type: "category_bb_textile",
        url: "/products/le-body-manche-courtes?variant=31656791703575"
      },
    
      "31656791736343": {
        variant_title: "18 mois - (81 cm) / Duo de bodies Manches Courtes - (Patch et Imprimé) / Brigitte",
        product_title: "le body manches courtes",
        price: '19.92',
        sku: "BODIES18M.RC.MC",
        product_type: "category_bb_textile",
        url: "/products/le-body-manche-courtes?variant=31656791736343"
      },
    
      "31656791769111": {
        variant_title: "18 mois - (81 cm) / Body individuel Manches Courtes - (Imprimé) / Malo",
        product_title: "le body manches courtes",
        price: '9.96',
        sku: "BODY18M.ML.MC",
        product_type: "category_bb_textile",
        url: "/products/le-body-manche-courtes?variant=31656791769111"
      },
    
      "31656791801879": {
        variant_title: "18 mois - (81 cm) / Body individuel Manches Courtes - (Patch) / Malo",
        product_title: "le body manches courtes",
        price: '9.96',
        sku: "BODYP18M.ML.MC",
        product_type: "category_bb_textile",
        url: "/products/le-body-manche-courtes?variant=31656791801879"
      },
    
      "31656791834647": {
        variant_title: "18 mois - (81 cm) / Duo de bodies Manches Courtes - (Patch et Imprimé) / Malo",
        product_title: "le body manches courtes",
        price: '19.92',
        sku: "BODIES18M.ML.MC",
        product_type: "category_bb_textile",
        url: "/products/le-body-manche-courtes?variant=31656791834647"
      },
    
      "31656792064023": {
        variant_title: "24 mois - (86 cm) / Body individuel Manches Courtes - (Imprimé) / Odette",
        product_title: "le body manches courtes",
        price: '9.96',
        sku: "BODY24M.P.MC",
        product_type: "category_bb_textile",
        url: "/products/le-body-manche-courtes?variant=31656792064023"
      },
    
      "31656792096791": {
        variant_title: "24 mois - (86 cm) / Body individuel Manches Courtes - (Patch) / Odette",
        product_title: "le body manches courtes",
        price: '9.96',
        sku: "BODYP24M.P.MC",
        product_type: "category_bb_textile",
        url: "/products/le-body-manche-courtes?variant=31656792096791"
      },
    
      "31656792129559": {
        variant_title: "24 mois - (86 cm) / Duo de bodies Manches Courtes - (Patch et Imprimé) / Odette",
        product_title: "le body manches courtes",
        price: '19.92',
        sku: "BODIES24M.P.MC",
        product_type: "category_bb_textile",
        url: "/products/le-body-manche-courtes?variant=31656792129559"
      },
    
      "31656792162327": {
        variant_title: "24 mois - (86 cm) / Body individuel Manches Courtes - (Imprimé) / Brigitte",
        product_title: "le body manches courtes",
        price: '9.96',
        sku: "BODY24M.RC.MC",
        product_type: "category_bb_textile",
        url: "/products/le-body-manche-courtes?variant=31656792162327"
      },
    
      "31656792195095": {
        variant_title: "24 mois - (86 cm) / Body individuel Manches Courtes - (Patch) / Brigitte",
        product_title: "le body manches courtes",
        price: '9.96',
        sku: "BODYP24M.RC.MC",
        product_type: "category_bb_textile",
        url: "/products/le-body-manche-courtes?variant=31656792195095"
      },
    
      "31656792227863": {
        variant_title: "24 mois - (86 cm) / Duo de bodies Manches Courtes - (Patch et Imprimé) / Brigitte",
        product_title: "le body manches courtes",
        price: '19.92',
        sku: "BODIES24M.RC.MC",
        product_type: "category_bb_textile",
        url: "/products/le-body-manche-courtes?variant=31656792227863"
      },
    
      "31656792260631": {
        variant_title: "24 mois - (86 cm) / Body individuel Manches Courtes - (Imprimé) / Malo",
        product_title: "le body manches courtes",
        price: '9.96',
        sku: "BODY24M.ML.MC",
        product_type: "category_bb_textile",
        url: "/products/le-body-manche-courtes?variant=31656792260631"
      },
    
      "31656792293399": {
        variant_title: "24 mois - (86 cm) / Body individuel Manches Courtes - (Patch) / Malo",
        product_title: "le body manches courtes",
        price: '9.96',
        sku: "BODYP24M.ML.MC",
        product_type: "category_bb_textile",
        url: "/products/le-body-manche-courtes?variant=31656792293399"
      },
    
      "31656792326167": {
        variant_title: "24 mois - (86 cm) / Duo de bodies Manches Courtes - (Patch et Imprimé) / Malo",
        product_title: "le body manches courtes",
        price: '19.92',
        sku: "BODIES24M.ML.MC",
        product_type: "category_bb_textile",
        url: "/products/le-body-manche-courtes?variant=31656792326167"
      },
    
  
    
      "31064227938327": {
        variant_title: "3 mois - (60cm) / Body individuel - (Imprimé) / Leon",
        product_title: "le body manches longues",
        price: '9.96',
        sku: "BODY3M.LE",
        product_type: "category_bb_textile",
        url: "/products/les-bodies?variant=31064227938327"
      },
    
      "31064229478423": {
        variant_title: "3 mois - (60cm) / Body individuel - (Imprimé) / Bernard",
        product_title: "le body manches longues",
        price: '9.96',
        sku: "BODY3M.BE",
        product_type: "category_bb_textile",
        url: "/products/les-bodies?variant=31064229478423"
      },
    
      "31064232394775": {
        variant_title: "3 mois - (60cm) / Body individuel - (Patch) / Leon",
        product_title: "le body manches longues",
        price: '24.90',
        sku: "BODYP3M.LE",
        product_type: "category_bb_textile",
        url: "/products/les-bodies?variant=31064232394775"
      },
    
      "31064232427543": {
        variant_title: "3 mois - (60cm) / Body individuel - (Patch) / Bernard",
        product_title: "le body manches longues",
        price: '9.96',
        sku: "BODYP3M.BE",
        product_type: "category_bb_textile",
        url: "/products/les-bodies?variant=31064232427543"
      },
    
      "31050904666135": {
        variant_title: "3 mois - (60cm) / Duo de bodies - (Patch et Imprimé) / Leon",
        product_title: "le body manches longues",
        price: '19.92',
        sku: "BODIES3M.LE",
        product_type: "category_bb_textile",
        url: "/products/les-bodies?variant=31050904666135"
      },
    
      "29498838745111": {
        variant_title: "3 mois - (60cm) / Duo de bodies - (Patch et Imprimé) / Bernard",
        product_title: "le body manches longues",
        price: '19.92',
        sku: "BODIES3M.BE",
        product_type: "category_bb_textile",
        url: "/products/les-bodies?variant=29498838745111"
      },
    
      "31064227971095": {
        variant_title: "6 mois - (67cm) / Body individuel - (Imprimé) / Leon",
        product_title: "le body manches longues",
        price: '9.96',
        sku: "BODY6M.LE",
        product_type: "category_bb_textile",
        url: "/products/les-bodies?variant=31064227971095"
      },
    
      "31064229511191": {
        variant_title: "6 mois - (67cm) / Body individuel - (Imprimé) / Bernard",
        product_title: "le body manches longues",
        price: '9.96',
        sku: "BODY6M.BE",
        product_type: "category_bb_textile",
        url: "/products/les-bodies?variant=31064229511191"
      },
    
      "31064232460311": {
        variant_title: "6 mois - (67cm) / Body individuel - (Patch) / Leon",
        product_title: "le body manches longues",
        price: '9.96',
        sku: "BODYP6M.LE",
        product_type: "category_bb_textile",
        url: "/products/les-bodies?variant=31064232460311"
      },
    
      "31064232493079": {
        variant_title: "6 mois - (67cm) / Body individuel - (Patch) / Bernard",
        product_title: "le body manches longues",
        price: '9.96',
        sku: "BODYP6M.BE",
        product_type: "category_bb_textile",
        url: "/products/les-bodies?variant=31064232493079"
      },
    
      "31050893525015": {
        variant_title: "6 mois - (67cm) / Duo de bodies - (Patch et Imprimé) / Leon",
        product_title: "le body manches longues",
        price: '19.92',
        sku: "BODIES6M.LE",
        product_type: "category_bb_textile",
        url: "/products/les-bodies?variant=31050893525015"
      },
    
      "29498842447895": {
        variant_title: "6 mois - (67cm) / Duo de bodies - (Patch et Imprimé) / Bernard",
        product_title: "le body manches longues",
        price: '19.92',
        sku: "BODIES6M.BE",
        product_type: "category_bb_textile",
        url: "/products/les-bodies?variant=29498842447895"
      },
    
      "31064228003863": {
        variant_title: "9 mois - (71 cm) / Body individuel - (Imprimé) / Leon",
        product_title: "le body manches longues",
        price: '9.96',
        sku: "BODY9M.LE",
        product_type: "category_bb_textile",
        url: "/products/les-bodies?variant=31064228003863"
      },
    
      "31064229543959": {
        variant_title: "9 mois - (71 cm) / Body individuel - (Imprimé) / Bernard",
        product_title: "le body manches longues",
        price: '9.96',
        sku: "BODY9M.BE",
        product_type: "category_bb_textile",
        url: "/products/les-bodies?variant=31064229543959"
      },
    
      "31064232558615": {
        variant_title: "9 mois - (71 cm) / Body individuel - (Patch) / Leon",
        product_title: "le body manches longues",
        price: '9.96',
        sku: "BODYP9M.LE",
        product_type: "category_bb_textile",
        url: "/products/les-bodies?variant=31064232558615"
      },
    
      "31064232591383": {
        variant_title: "9 mois - (71 cm) / Body individuel - (Patch) / Bernard",
        product_title: "le body manches longues",
        price: '9.96',
        sku: "BODYP9M.BE",
        product_type: "category_bb_textile",
        url: "/products/les-bodies?variant=31064232591383"
      },
    
      "31064216076311": {
        variant_title: "9 mois - (71 cm) / Duo de bodies - (Patch et Imprimé) / Leon",
        product_title: "le body manches longues",
        price: '19.92',
        sku: "BODIES9M.LE",
        product_type: "category_bb_textile",
        url: "/products/les-bodies?variant=31064216076311"
      },
    
      "31064216109079": {
        variant_title: "9 mois - (71 cm) / Duo de bodies - (Patch et Imprimé) / Bernard",
        product_title: "le body manches longues",
        price: '19.92',
        sku: "BODIES9M.BE",
        product_type: "category_bb_textile",
        url: "/products/les-bodies?variant=31064216109079"
      },
    
      "31064228036631": {
        variant_title: "12 mois - (74 cm) / Body individuel - (Imprimé) / Leon",
        product_title: "le body manches longues",
        price: '9.96',
        sku: "BODY12M.LE",
        product_type: "category_bb_textile",
        url: "/products/les-bodies?variant=31064228036631"
      },
    
      "31064229740567": {
        variant_title: "12 mois - (74 cm) / Body individuel - (Imprimé) / Bernard",
        product_title: "le body manches longues",
        price: '9.96',
        sku: "BODY12M.BE",
        product_type: "category_bb_textile",
        url: "/products/les-bodies?variant=31064229740567"
      },
    
      "31064232624151": {
        variant_title: "12 mois - (74 cm) / Body individuel - (Patch) / Leon",
        product_title: "le body manches longues",
        price: '9.96',
        sku: "BODYP12M.LE",
        product_type: "category_bb_textile",
        url: "/products/les-bodies?variant=31064232624151"
      },
    
      "31064232656919": {
        variant_title: "12 mois - (74 cm) / Body individuel - (Patch) / Bernard",
        product_title: "le body manches longues",
        price: '9.96',
        sku: "BODYP12M.BE",
        product_type: "category_bb_textile",
        url: "/products/les-bodies?variant=31064232656919"
      },
    
      "31064217223191": {
        variant_title: "12 mois - (74 cm) / Duo de bodies - (Patch et Imprimé) / Leon",
        product_title: "le body manches longues",
        price: '19.92',
        sku: "BODIES12M.LE",
        product_type: "category_bb_textile",
        url: "/products/les-bodies?variant=31064217223191"
      },
    
      "31064217255959": {
        variant_title: "12 mois - (74 cm) / Duo de bodies - (Patch et Imprimé) / Bernard",
        product_title: "le body manches longues",
        price: '19.92',
        sku: "BODIES12M.BE",
        product_type: "category_bb_textile",
        url: "/products/les-bodies?variant=31064217255959"
      },
    
      "31064228069399": {
        variant_title: "18 mois - (81 cm) / Body individuel - (Imprimé) / Leon",
        product_title: "le body manches longues",
        price: '9.96',
        sku: "BODY18M.LE",
        product_type: "category_bb_textile",
        url: "/products/les-bodies?variant=31064228069399"
      },
    
      "31064229838871": {
        variant_title: "18 mois - (81 cm) / Body individuel - (Imprimé) / Bernard",
        product_title: "le body manches longues",
        price: '9.96',
        sku: "BODY18M.BE",
        product_type: "category_bb_textile",
        url: "/products/les-bodies?variant=31064229838871"
      },
    
      "31064232689687": {
        variant_title: "18 mois - (81 cm) / Body individuel - (Patch) / Leon",
        product_title: "le body manches longues",
        price: '9.96',
        sku: "BODYP18M.LE",
        product_type: "category_bb_textile",
        url: "/products/les-bodies?variant=31064232689687"
      },
    
      "31064232722455": {
        variant_title: "18 mois - (81 cm) / Body individuel - (Patch) / Bernard",
        product_title: "le body manches longues",
        price: '9.96',
        sku: "BODYP18M.BE",
        product_type: "category_bb_textile",
        url: "/products/les-bodies?variant=31064232722455"
      },
    
      "31064219648023": {
        variant_title: "18 mois - (81 cm) / Duo de bodies - (Patch et Imprimé) / Leon",
        product_title: "le body manches longues",
        price: '19.92',
        sku: "BODIES18M.LE",
        product_type: "category_bb_textile",
        url: "/products/les-bodies?variant=31064219648023"
      },
    
      "31064220041239": {
        variant_title: "18 mois - (81 cm) / Duo de bodies - (Patch et Imprimé) / Bernard",
        product_title: "le body manches longues",
        price: '19.92',
        sku: "BODIES18M.BE",
        product_type: "category_bb_textile",
        url: "/products/les-bodies?variant=31064220041239"
      },
    
      "31064228102167": {
        variant_title: "24 mois - (86 cm) / Body individuel - (Imprimé) / Leon",
        product_title: "le body manches longues",
        price: '9.96',
        sku: "BODY24M.LE",
        product_type: "category_bb_textile",
        url: "/products/les-bodies?variant=31064228102167"
      },
    
      "31064229871639": {
        variant_title: "24 mois - (86 cm) / Body individuel - (Imprimé) / Bernard",
        product_title: "le body manches longues",
        price: '9.96',
        sku: "BODY24M.BE",
        product_type: "category_bb_textile",
        url: "/products/les-bodies?variant=31064229871639"
      },
    
      "31064232755223": {
        variant_title: "24 mois - (86 cm) / Body individuel - (Patch) / Leon",
        product_title: "le body manches longues",
        price: '9.96',
        sku: "BODYP24M.LE",
        product_type: "category_bb_textile",
        url: "/products/les-bodies?variant=31064232755223"
      },
    
      "31064232787991": {
        variant_title: "24 mois - (86 cm) / Body individuel - (Patch) / Bernard",
        product_title: "le body manches longues",
        price: '9.96',
        sku: "BODYP24M.BE",
        product_type: "category_bb_textile",
        url: "/products/les-bodies?variant=31064232787991"
      },
    
      "31064222498839": {
        variant_title: "24 mois - (86 cm) / Duo de bodies - (Patch et Imprimé) / Leon",
        product_title: "le body manches longues",
        price: '19.92',
        sku: "BODIES24M.LE",
        product_type: "category_bb_textile",
        url: "/products/les-bodies?variant=31064222498839"
      },
    
      "31064222531607": {
        variant_title: "24 mois - (86 cm) / Duo de bodies - (Patch et Imprimé) / Bernard",
        product_title: "le body manches longues",
        price: '19.92',
        sku: "BODIES24M.BE",
        product_type: "category_bb_textile",
        url: "/products/les-bodies?variant=31064222531607"
      },
    
  
    
      "41563073249303": {
        variant_title: "Default Title",
        product_title: "Le coffret bain et hydratation",
        price: '49.90',
        sku: "CF.RIT.BAIN.HYD",
        product_type: "category_bb_cosmetics",
        url: "/products/le-rituel-bain-hydratation?variant=41563073249303"
      },
    
  
    
      "40915440336919": {
        variant_title: "T1 (2 à 4 kg) - 60 COUCHES FSC Mix* / Brigitte",
        product_title: "le coffret découverte",
        price: '22.90',
        sku: "CF.SIMP.CL50.RC.IDV.T1",
        product_type: "category_bb_cosmetics",
        url: "/products/coffret-decouverte?variant=40915440336919"
      },
    
      "40915440369687": {
        variant_title: "T1 (2 à 4 kg) - 60 COUCHES FSC Mix* / Malo",
        product_title: "le coffret découverte",
        price: '22.90',
        sku: "CF.SIMP.CL50.ML.IDV.T1",
        product_type: "category_bb_cosmetics",
        url: "/products/coffret-decouverte?variant=40915440369687"
      },
    
      "40915440402455": {
        variant_title: "T1 (2 à 4 kg) - 60 COUCHES FSC Mix* / Blanc",
        product_title: "le coffret découverte",
        price: '22.90',
        sku: "CF.SIMP.CL50.BL.IDV.T1",
        product_type: "category_bb_cosmetics",
        url: "/products/coffret-decouverte?variant=40915440402455"
      },
    
      "40915440435223": {
        variant_title: "T2 (3 à 5 kg) - 64 COUCHES FSC Mix* / Brigitte",
        product_title: "le coffret découverte",
        price: '22.90',
        sku: "CF.SIMP.CL50.RC.IDV.T2",
        product_type: "category_bb_cosmetics",
        url: "/products/coffret-decouverte?variant=40915440435223"
      },
    
      "40915440467991": {
        variant_title: "T2 (3 à 5 kg) - 64 COUCHES FSC Mix* / Malo",
        product_title: "le coffret découverte",
        price: '22.90',
        sku: "CF.SIMP.CL50.ML.IDV.T2",
        product_type: "category_bb_cosmetics",
        url: "/products/coffret-decouverte?variant=40915440467991"
      },
    
      "40915440500759": {
        variant_title: "T2 (3 à 5 kg) - 64 COUCHES FSC Mix* / Odette",
        product_title: "le coffret découverte",
        price: '22.90',
        sku: "CF.SIMP.CL50.P.IDV.T2",
        product_type: "category_bb_cosmetics",
        url: "/products/coffret-decouverte?variant=40915440500759"
      },
    
      "40915440533527": {
        variant_title: "T2 (3 à 5 kg) - 64 COUCHES FSC Mix* / Barbara",
        product_title: "le coffret découverte",
        price: '22.90',
        sku: "CF.SIMP.CL50.BAR.IDV.T2",
        product_type: "category_bb_cosmetics",
        url: "/products/coffret-decouverte?variant=40915440533527"
      },
    
      "40915440566295": {
        variant_title: "T2 (3 à 5 kg) - 64 COUCHES FSC Mix* / Bernard",
        product_title: "le coffret découverte",
        price: '22.90',
        sku: "CF.SIMP.CL50.BE.IDV.T2",
        product_type: "category_bb_cosmetics",
        url: "/products/coffret-decouverte?variant=40915440566295"
      },
    
      "40915440599063": {
        variant_title: "T2 (3 à 5 kg) - 64 COUCHES FSC Mix* / Leon",
        product_title: "le coffret découverte",
        price: '22.90',
        sku: "CF.SIMP.CL50.LE.IDV.T2",
        product_type: "category_bb_cosmetics",
        url: "/products/coffret-decouverte?variant=40915440599063"
      },
    
      "40915440664599": {
        variant_title: "T3 (4 à 8 kg) - 54 COUCHES FSC Mix* / Brigitte",
        product_title: "le coffret découverte",
        price: '22.90',
        sku: "CF.SIMP.CL50.RC.IDV.T3",
        product_type: "category_bb_cosmetics",
        url: "/products/coffret-decouverte?variant=40915440664599"
      },
    
      "40915440697367": {
        variant_title: "T3 (4 à 8 kg) - 54 COUCHES FSC Mix* / Malo",
        product_title: "le coffret découverte",
        price: '22.90',
        sku: "CF.SIMP.CL50.ML.IDV.T3",
        product_type: "category_bb_cosmetics",
        url: "/products/coffret-decouverte?variant=40915440697367"
      },
    
      "40915440730135": {
        variant_title: "T3 (4 à 8 kg) - 54 COUCHES FSC Mix* / Odette",
        product_title: "le coffret découverte",
        price: '22.90',
        sku: "CF.SIMP.CL50.P.IDV.T3",
        product_type: "category_bb_cosmetics",
        url: "/products/coffret-decouverte?variant=40915440730135"
      },
    
      "40915440762903": {
        variant_title: "T3 (4 à 8 kg) - 54 COUCHES FSC Mix* / Barbara",
        product_title: "le coffret découverte",
        price: '22.90',
        sku: "CF.SIMP.CL50.BAR.IDV.T3",
        product_type: "category_bb_cosmetics",
        url: "/products/coffret-decouverte?variant=40915440762903"
      },
    
      "40915440795671": {
        variant_title: "T3 (4 à 8 kg) - 54 COUCHES FSC Mix* / Bernard",
        product_title: "le coffret découverte",
        price: '22.90',
        sku: "CF.SIMP.CL50.BE.IDV.T3",
        product_type: "category_bb_cosmetics",
        url: "/products/coffret-decouverte?variant=40915440795671"
      },
    
      "40915440828439": {
        variant_title: "T3 (4 à 8 kg) - 54 COUCHES FSC Mix* / Leon",
        product_title: "le coffret découverte",
        price: '22.90',
        sku: "CF.SIMP.CL50.LE.IDV.T3",
        product_type: "category_bb_cosmetics",
        url: "/products/coffret-decouverte?variant=40915440828439"
      },
    
      "40915440893975": {
        variant_title: "T4 (7 à 14 kg) - 48 COUCHES FSC Mix* / Brigitte",
        product_title: "le coffret découverte",
        price: '22.90',
        sku: "CF.SIMP.CL50.RC.IDV.T4",
        product_type: "category_bb_cosmetics",
        url: "/products/coffret-decouverte?variant=40915440893975"
      },
    
      "40915440926743": {
        variant_title: "T4 (7 à 14 kg) - 48 COUCHES FSC Mix* / Malo",
        product_title: "le coffret découverte",
        price: '22.90',
        sku: "CF.SIMP.CL50.ML.IDV.T4",
        product_type: "category_bb_cosmetics",
        url: "/products/coffret-decouverte?variant=40915440926743"
      },
    
      "40915440959511": {
        variant_title: "T4 (7 à 14 kg) - 48 COUCHES FSC Mix* / Odette",
        product_title: "le coffret découverte",
        price: '22.90',
        sku: "CF.SIMP.CL50.P.IDV.T4",
        product_type: "category_bb_cosmetics",
        url: "/products/coffret-decouverte?variant=40915440959511"
      },
    
      "40915440992279": {
        variant_title: "T4 (7 à 14 kg) - 48 COUCHES FSC Mix* / Barbara",
        product_title: "le coffret découverte",
        price: '22.90',
        sku: "CF.SIMP.CL50.BAR.IDV.T4",
        product_type: "category_bb_cosmetics",
        url: "/products/coffret-decouverte?variant=40915440992279"
      },
    
      "40915441025047": {
        variant_title: "T4 (7 à 14 kg) - 48 COUCHES FSC Mix* / Bernard",
        product_title: "le coffret découverte",
        price: '22.90',
        sku: "CF.SIMP.CL50.BE.IDV.T4",
        product_type: "category_bb_cosmetics",
        url: "/products/coffret-decouverte?variant=40915441025047"
      },
    
      "40915441057815": {
        variant_title: "T4 (7 à 14 kg) - 48 COUCHES FSC Mix* / Leon",
        product_title: "le coffret découverte",
        price: '22.90',
        sku: "CF.SIMP.CL50.LE.IDV.T4",
        product_type: "category_bb_cosmetics",
        url: "/products/coffret-decouverte?variant=40915441057815"
      },
    
      "40915441123351": {
        variant_title: "T5 (10 à 18 kg) - 40 COUCHES FSC Mix* / Brigitte",
        product_title: "le coffret découverte",
        price: '22.90',
        sku: "CF.SIMP.CL50.RC.IDV.T5",
        product_type: "category_bb_cosmetics",
        url: "/products/coffret-decouverte?variant=40915441123351"
      },
    
      "40915441156119": {
        variant_title: "T5 (10 à 18 kg) - 40 COUCHES FSC Mix* / Malo",
        product_title: "le coffret découverte",
        price: '22.90',
        sku: "CF.SIMP.CL50.ML.IDV.T5",
        product_type: "category_bb_cosmetics",
        url: "/products/coffret-decouverte?variant=40915441156119"
      },
    
      "40915441188887": {
        variant_title: "T5 (10 à 18 kg) - 40 COUCHES FSC Mix* / Odette",
        product_title: "le coffret découverte",
        price: '22.90',
        sku: "CF.SIMP.CL50.P.IDV.T5",
        product_type: "category_bb_cosmetics",
        url: "/products/coffret-decouverte?variant=40915441188887"
      },
    
      "40915441221655": {
        variant_title: "T5 (10 à 18 kg) - 40 COUCHES FSC Mix* / Barbara",
        product_title: "le coffret découverte",
        price: '22.90',
        sku: "CF.SIMP.CL50.BAR.IDV.T5",
        product_type: "category_bb_cosmetics",
        url: "/products/coffret-decouverte?variant=40915441221655"
      },
    
      "40915441254423": {
        variant_title: "T5 (10 à 18 kg) - 40 COUCHES FSC Mix* / Bernard",
        product_title: "le coffret découverte",
        price: '22.90',
        sku: "CF.SIMP.CL50.BE.IDV.T5",
        product_type: "category_bb_cosmetics",
        url: "/products/coffret-decouverte?variant=40915441254423"
      },
    
      "40915441287191": {
        variant_title: "T5 (10 à 18 kg) - 40 COUCHES FSC Mix* / Leon",
        product_title: "le coffret découverte",
        price: '22.90',
        sku: "CF.SIMP.CL50.LE.IDV.T5",
        product_type: "category_bb_cosmetics",
        url: "/products/coffret-decouverte?variant=40915441287191"
      },
    
      "40915441352727": {
        variant_title: "T6 (16 à 30 kg) - 38 COUCHES FSC Mix* / Brigitte",
        product_title: "le coffret découverte",
        price: '22.90',
        sku: "CF.SIMP.CL50.RC.IDV.T6",
        product_type: "category_bb_cosmetics",
        url: "/products/coffret-decouverte?variant=40915441352727"
      },
    
      "40915441385495": {
        variant_title: "T6 (16 à 30 kg) - 38 COUCHES FSC Mix* / Malo",
        product_title: "le coffret découverte",
        price: '22.90',
        sku: "CF.SIMP.CL50.ML.IDV.T6",
        product_type: "category_bb_cosmetics",
        url: "/products/coffret-decouverte?variant=40915441385495"
      },
    
      "40915441418263": {
        variant_title: "T6 (16 à 30 kg) - 38 COUCHES FSC Mix* / Odette",
        product_title: "le coffret découverte",
        price: '22.90',
        sku: "CF.SIMP.CL50.P.IDV.T6",
        product_type: "category_bb_cosmetics",
        url: "/products/coffret-decouverte?variant=40915441418263"
      },
    
      "40915441451031": {
        variant_title: "T6 (16 à 30 kg) - 38 COUCHES FSC Mix* / Bernard",
        product_title: "le coffret découverte",
        price: '22.90',
        sku: "CF.SIMP.CL50.BE.IDV.T6",
        product_type: "category_bb_cosmetics",
        url: "/products/coffret-decouverte?variant=40915441451031"
      },
    
      "40915441483799": {
        variant_title: "T6 (16 à 30 kg) - 38 COUCHES FSC Mix* / Leon",
        product_title: "le coffret découverte",
        price: '22.90',
        sku: "CF.SIMP.CL50.LE.IDV.T6",
        product_type: "category_bb_cosmetics",
        url: "/products/coffret-decouverte?variant=40915441483799"
      },
    
  
    
      "40346435780631": {
        variant_title: "Default Title",
        product_title: "le coffret eau de senteur & lange",
        price: '17.97',
        sku: "CF.BB.ENF",
        product_type: "category_bb_cosmetics",
        url: "/products/coffret-eau-de-senteur-lange-retail?variant=40346435780631"
      },
    
  
    
      "32953645006871": {
        variant_title: "T1 + T2 - T1 60 couches + T2 64 couches FSC Mix* / Malo",
        product_title: "le coffret maternité iconique",
        price: '149.90',
        sku: "CF.MAT4.ML.ML.IDV.T2",
        product_type: "category_bb_cosmetics",
        url: "/products/coffret-maternite?variant=32953645006871"
      },
    
      "32953645137943": {
        variant_title: "T1 + T2 - T1 60 couches + T2 64 couches FSC Mix* / Bernard",
        product_title: "le coffret maternité iconique",
        price: '149.90',
        sku: "CF.MAT4.BE.BE.IDV.T2",
        product_type: "category_bb_cosmetics",
        url: "/products/coffret-maternite?variant=32953645137943"
      },
    
      "32953645105175": {
        variant_title: "T1 + T2 - T1 60 couches + T2 64 couches FSC Mix* / Leon",
        product_title: "le coffret maternité iconique",
        price: '149.90',
        sku: "CF.MAT4.LE.LE.IDV.T2",
        product_type: "category_bb_cosmetics",
        url: "/products/coffret-maternite?variant=32953645105175"
      },
    
      "40347028324375": {
        variant_title: "T1 + T2 - T1 60 couches + T2 64 couches FSC Mix* / Barbara",
        product_title: "le coffret maternité iconique",
        price: '149.90',
        sku: "CF.MAT4.BAR.BAR.IDV.T2",
        product_type: "category_bb_cosmetics",
        url: "/products/coffret-maternite?variant=40347028324375"
      },
    
      "32953645334551": {
        variant_title: "T1 + T2 - T1 60 couches + T2 64 couches FSC Mix* / Brigitte_indisponible",
        product_title: "le coffret maternité iconique",
        price: '149.90',
        sku: "CF.MAT4.RC.RC.IDV.T2",
        product_type: "category_bb_cosmetics",
        url: "/products/coffret-maternite?variant=32953645334551"
      },
    
      "32953645072407": {
        variant_title: "T1 + T2 - T1 60 couches + T2 64 couches FSC Mix* / Odette_indisponible",
        product_title: "le coffret maternité iconique",
        price: '149.90',
        sku: "CF.MAT4.P.PA.IDV.T2",
        product_type: "category_bb_cosmetics",
        url: "/products/coffret-maternite?variant=32953645072407"
      },
    
      "32953645170711": {
        variant_title: "T2 + T3 - T2 64 couches + T3 54 couches FSC Mix* / Malo",
        product_title: "le coffret maternité iconique",
        price: '149.90',
        sku: "CF.MAT4.ML.T2.ML.IDV.T3",
        product_type: "category_bb_cosmetics",
        url: "/products/coffret-maternite?variant=32953645170711"
      },
    
      "32953645301783": {
        variant_title: "T2 + T3 - T2 64 couches + T3 54 couches FSC Mix* / Bernard",
        product_title: "le coffret maternité iconique",
        price: '149.90',
        sku: "CF.MAT4.BE.T2.BE.IDV.T3",
        product_type: "category_bb_cosmetics",
        url: "/products/coffret-maternite?variant=32953645301783"
      },
    
      "32953645269015": {
        variant_title: "T2 + T3 - T2 64 couches + T3 54 couches FSC Mix* / Leon",
        product_title: "le coffret maternité iconique",
        price: '149.90',
        sku: "CF.MAT4.LE.T2.LE.IDV.T3",
        product_type: "category_bb_cosmetics",
        url: "/products/coffret-maternite?variant=32953645269015"
      },
    
      "32953645203479": {
        variant_title: "T2 + T3 - T2 64 couches + T3 54 couches FSC Mix* / Barbara",
        product_title: "le coffret maternité iconique",
        price: '149.90',
        sku: "CF.MAT4.BAR.T2.BAR.IDV.T3",
        product_type: "category_bb_cosmetics",
        url: "/products/coffret-maternite?variant=32953645203479"
      },
    
      "32953645367319": {
        variant_title: "T2 + T3 - T2 64 couches + T3 54 couches FSC Mix* / Brigitte_indisponible",
        product_title: "le coffret maternité iconique",
        price: '149.90',
        sku: "CF.MAT4.RC.T2.RC.IDV.T3",
        product_type: "category_bb_cosmetics",
        url: "/products/coffret-maternite?variant=32953645367319"
      },
    
      "32953645236247": {
        variant_title: "T2 + T3 - T2 64 couches + T3 54 couches FSC Mix* / Odette_indisponible",
        product_title: "le coffret maternité iconique",
        price: '149.90',
        sku: "CF.MAT4.P.T2.P.IDV.T3",
        product_type: "category_bb_cosmetics",
        url: "/products/coffret-maternite?variant=32953645236247"
      },
    
  
    
      "32953645924375": {
        variant_title: "T1 60 couches FSC Mix* / Malo",
        product_title: "le coffret naissance",
        price: '49.90',
        sku: "CF.NAIS4.ML.IDV.T1",
        product_type: "category_bb_cosmetics",
        url: "/products/coffret-naissance?variant=32953645924375"
      },
    
      "32953646252055": {
        variant_title: "T1 60 couches FSC Mix* / Brigitte",
        product_title: "le coffret naissance",
        price: '49.90',
        sku: "CF.NAIS4.RC.IDV.T1",
        product_type: "category_bb_cosmetics",
        url: "/products/coffret-naissance?variant=32953646252055"
      },
    
      "32953646088215": {
        variant_title: "T2 64 couches FSC Mix* / Malo",
        product_title: "le coffret naissance",
        price: '49.90',
        sku: "CF.NAIS4.ML.IDV.T2",
        product_type: "category_bb_cosmetics",
        url: "/products/coffret-naissance?variant=32953646088215"
      },
    
      "32953646284823": {
        variant_title: "T2 64 couches FSC Mix* / Brigitte",
        product_title: "le coffret naissance",
        price: '49.90',
        sku: "CF.NAIS4.RC.IDV.T2",
        product_type: "category_bb_cosmetics",
        url: "/products/coffret-naissance?variant=32953646284823"
      },
    
      "32953646219287": {
        variant_title: "T2 64 couches FSC Mix* / Bernard",
        product_title: "le coffret naissance",
        price: '49.90',
        sku: "CF.NAIS4.BE.IDV.T2",
        product_type: "category_bb_cosmetics",
        url: "/products/coffret-naissance?variant=32953646219287"
      },
    
      "32953646186519": {
        variant_title: "T2 64 couches FSC Mix* / Leon",
        product_title: "le coffret naissance",
        price: '49.90',
        sku: "CF.NAIS4.LE.IDV.T2",
        product_type: "category_bb_cosmetics",
        url: "/products/coffret-naissance?variant=32953646186519"
      },
    
      "32953646153751": {
        variant_title: "T2 64 couches FSC Mix* / Odette",
        product_title: "le coffret naissance",
        price: '49.90',
        sku: "CF.NAIS4.P.IDV.T2",
        product_type: "category_bb_cosmetics",
        url: "/products/coffret-naissance?variant=32953646153751"
      },
    
      "32953646120983": {
        variant_title: "T2 64 couches FSC Mix* / Barbara",
        product_title: "le coffret naissance",
        price: '49.90',
        sku: "CF.NAIS4.BAR.IDV.T2",
        product_type: "category_bb_cosmetics",
        url: "/products/coffret-naissance?variant=32953646120983"
      },
    
      "41659623440407": {
        variant_title: "T3 54 couches FSC Mix* / Malo",
        product_title: "le coffret naissance",
        price: '49.90',
        sku: "CF.NAIS4.ML.IDV.T3",
        product_type: "category_bb_cosmetics",
        url: "/products/coffret-naissance?variant=41659623440407"
      },
    
      "41659623473175": {
        variant_title: "T3 54 couches FSC Mix* / Brigitte",
        product_title: "le coffret naissance",
        price: '49.90',
        sku: "CF.NAIS4.RC.IDV.T3",
        product_type: "category_bb_cosmetics",
        url: "/products/coffret-naissance?variant=41659623473175"
      },
    
      "41659623505943": {
        variant_title: "T3 54 couches FSC Mix* / Bernard",
        product_title: "le coffret naissance",
        price: '49.90',
        sku: "CF.NAIS4.BE.IDV.T3",
        product_type: "category_bb_cosmetics",
        url: "/products/coffret-naissance?variant=41659623505943"
      },
    
      "41659623538711": {
        variant_title: "T3 54 couches FSC Mix* / Leon",
        product_title: "le coffret naissance",
        price: '49.90',
        sku: "CF.NAIS4.LE.IDV.T3",
        product_type: "category_bb_cosmetics",
        url: "/products/coffret-naissance?variant=41659623538711"
      },
    
      "41659623571479": {
        variant_title: "T3 54 couches FSC Mix* / Odette",
        product_title: "le coffret naissance",
        price: '49.90',
        sku: "CF.NAIS4.P.IDV.T3",
        product_type: "category_bb_cosmetics",
        url: "/products/coffret-naissance?variant=41659623571479"
      },
    
      "41659623604247": {
        variant_title: "T3 54 couches FSC Mix* / Barbara",
        product_title: "le coffret naissance",
        price: '49.90',
        sku: "CF.NAIS4.BAR.IDV.T3",
        product_type: "category_bb_cosmetics",
        url: "/products/coffret-naissance?variant=41659623604247"
      },
    
  
    
      "12922542587927": {
        variant_title: "Default Title",
        product_title: "le coffret soins essentiels",
        price: '29.90',
        sku: "CF.ESS4.CM.IDV",
        product_type: "category_bb_cosmetics",
        url: "/products/coffret-lessentiel?variant=12922542587927"
      },
    
  
    
      "40485440290839": {
        variant_title: "1 mois",
        product_title: "Le complément cheveux",
        price: '22.90',
        sku: "CA.CHEV.IDV",
        product_type: "category_wom_cosmetics",
        url: "/products/complement-alimentaire-cheveux?variant=40485440290839"
      },
    
      "40485440323607": {
        variant_title: "2 mois",
        product_title: "Le complément cheveux",
        price: '45.80',
        sku: "CA.CHEV.IDV-2",
        product_type: "category_wom_cosmetics",
        url: "/products/complement-alimentaire-cheveux?variant=40485440323607"
      },
    
      "40485440356375": {
        variant_title: "3 mois",
        product_title: "Le complément cheveux",
        price: '45.80',
        sku: "CA.CHEV.IDV-3",
        product_type: "category_wom_cosmetics",
        url: "/products/complement-alimentaire-cheveux?variant=40485440356375"
      },
    
  
    
      "40515209461783": {
        variant_title: "1 mois",
        product_title: "Le complément vitalité",
        price: '22.90',
        sku: "CA.VITA.IDV",
        product_type: "category_wom_cosmetics",
        url: "/products/complement-alimentaire-vitalite?variant=40515209461783"
      },
    
      "40515209494551": {
        variant_title: "2 mois",
        product_title: "Le complément vitalité",
        price: '45.80',
        sku: "CA.VITA.IDV-2",
        product_type: "category_wom_cosmetics",
        url: "/products/complement-alimentaire-vitalite?variant=40515209494551"
      },
    
      "40515209527319": {
        variant_title: "3 mois",
        product_title: "Le complément vitalité",
        price: '45.80',
        sku: "CA.VITA.IDV-3",
        product_type: "category_wom_cosmetics",
        url: "/products/complement-alimentaire-vitalite?variant=40515209527319"
      },
    
  
    
      "40109648936983": {
        variant_title: "9 mois",
        product_title: "Le débardeur Tartine et Chocolat",
        price: '20.00',
        sku: "DEBARD.TEC.9M",
        product_type: "category_bb_textile",
        url: "/products/debardeurs-tartine-et-chocolat?variant=40109648936983"
      },
    
      "40109648969751": {
        variant_title: "12 mois",
        product_title: "Le débardeur Tartine et Chocolat",
        price: '20.00',
        sku: "DEBARD.TEC.12M",
        product_type: "category_bb_textile",
        url: "/products/debardeurs-tartine-et-chocolat?variant=40109648969751"
      },
    
      "40109649002519": {
        variant_title: "18 mois",
        product_title: "Le débardeur Tartine et Chocolat",
        price: '20.00',
        sku: "DEBARD.TEC.18M",
        product_type: "category_bb_textile",
        url: "/products/debardeurs-tartine-et-chocolat?variant=40109649002519"
      },
    
      "40109649035287": {
        variant_title: "24 mois",
        product_title: "Le débardeur Tartine et Chocolat",
        price: '20.00',
        sku: "DEBARD.TEC.24M",
        product_type: "category_bb_textile",
        url: "/products/debardeurs-tartine-et-chocolat?variant=40109649035287"
      },
    
      "40109649068055": {
        variant_title: "36 mois",
        product_title: "Le débardeur Tartine et Chocolat",
        price: '40.00',
        sku: "DEBARD.TEC.36M",
        product_type: "category_bb_textile",
        url: "/products/debardeurs-tartine-et-chocolat?variant=40109649068055"
      },
    
  
    
      "54540845613435": {
        variant_title: "Dentifrice - 1 tube COSMOS ORGANIC",
        product_title: "Le dentifrice - COSMOS ORGANIC",
        price: '6.90',
        sku: "DENT.ENF.IDV",
        product_type: "category_bb_cosmetics",
        url: "/products/dentifrice-enfant?variant=54540845613435"
      },
    
      "54540843909499": {
        variant_title: "OFFRE SPÉCIALE - 2 tubes + 1 brosse à dents offerte COSMOS ORGANIC",
        product_title: "Le dentifrice - COSMOS ORGANIC",
        price: '13.80',
        sku: "CF.DENT.ENF.IDV",
        product_type: "category_bb_cosmetics",
        url: "/products/dentifrice-enfant?variant=54540843909499"
      },
    
  
    
      "39259223359511": {
        variant_title: "Default Title",
        product_title: "le déodorant (COSMOS ORGANIC)",
        price: '9.90',
        sku: "DEO.KIDS.IDV",
        product_type: "category_bb_cosmetics",
        url: "/products/deodorant-ado?variant=39259223359511"
      },
    
  
    
      "55221043233147": {
        variant_title: "Default Title",
        product_title: "Le Gant de toilette - Archives",
        price: '6.93',
        sku: "GANT.TOIL",
        product_type: "",
        url: "/products/le-gant-de-toilette?variant=55221043233147"
      },
    
  
    
      "39421801267223": {
        variant_title: "le gel hygiène intime (7ml)",
        product_title: "le gel hygiène intime (7ml)",
        price: '0.00',
        sku: "ECH.GHI",
        product_type: "",
        url: "/products/echantillon-gel-hygiene-intime?variant=39421801267223"
      },
    
  
    
      "31290584858647": {
        variant_title: "Default Title",
        product_title: "Le gel hygiène intime (COSMOS ORGANIC)",
        price: '11.90',
        sku: "GHI.IDV",
        product_type: "category_wom_cosmetics",
        url: "/products/gel-hygiene-intime?variant=31290584858647"
      },
    
  
    
      "40150369861655": {
        variant_title: "Le gel lavant 400ml - COSMOS ORGANIC",
        product_title: "le gel lavant (COSMOS ORGANIC)",
        price: '11.90',
        sku: "LAV4.IDV",
        product_type: "category_bb_cosmetics",
        url: "/products/gel-lavant?variant=40150369861655"
      },
    
      "40150369894423": {
        variant_title: "La recharge 400ml - COSMOS ORGANIC",
        product_title: "le gel lavant (COSMOS ORGANIC)",
        price: '11.90',
        sku: "RECHARG.LAV",
        product_type: "category_bb_cosmetics",
        url: "/products/gel-lavant?variant=40150369894423"
      },
    
  
    
      "40827839971351": {
        variant_title: "Default Title",
        product_title: "Le gel lavant 100ML - Archives (COSMOS ORGANIC)",
        price: '2.50',
        sku: "LAV.100",
        product_type: "category_bb_cosmetics",
        url: "/products/le-gel-lavant-100ml-archives?variant=40827839971351"
      },
    
  
    
      "41609532538903": {
        variant_title: "Default Title",
        product_title: "Le gel lavant 100ML - COSMOS ORGANIC",
        price: '4.90',
        sku: "LAV2.100.IDV",
        product_type: "category_bb_cosmetics",
        url: "/products/le-gel-lavant-100ml?variant=41609532538903"
      },
    
  
    
      "39246461337623": {
        variant_title: "Default Title",
        product_title: "le kit d'essai serviettes hygiéniques",
        price: '0.00',
        sku: "ECH.SERV.HYG.3.1",
        product_type: "",
        url: "/products/echantillon-serviettes-hygieniques-3j-1n?variant=39246461337623"
      },
    
  
    
      "55213675512187": {
        variant_title: "Default Title",
        product_title: "Le Kit Future-Maman",
        price: '79.00',
        sku: "CF.FUTURE.MAMAN",
        product_type: "category_wom_cosmetics",
        url: "/products/le-kit-future-maman?variant=55213675512187"
      },
    
  
    
      "12920037048343": {
        variant_title: "Default Title",
        product_title: "le lait hydratant (COSMOS ORGANIC)",
        price: '15.90',
        sku: "LH.IDV",
        product_type: "category_bb_cosmetics",
        url: "/products/lait-hydratant?variant=12920037048343"
      },
    
  
    
      "41609534898199": {
        variant_title: "Default Title",
        product_title: "Le lait hydratant 100ML - COSMOS ORGANIC",
        price: '4.90',
        sku: "LH2.100.IDV",
        product_type: "category_bb_cosmetics",
        url: "/products/le-lait-hydratant-100ml?variant=41609534898199"
      },
    
  
    
      "40641558478871": {
        variant_title: "Oscar",
        product_title: "le lange",
        price: '11.94',
        sku: "LAN.OSC",
        product_type: "category_bb_textile",
        url: "/products/lange?variant=40641558478871"
      },
    
      "13260256641047": {
        variant_title: "Malo",
        product_title: "le lange",
        price: '11.94',
        sku: "LAN.ML",
        product_type: "category_bb_textile",
        url: "/products/lange?variant=13260256641047"
      },
    
      "13045273985047": {
        variant_title: "Bernard",
        product_title: "le lange",
        price: '11.94',
        sku: "LAN.BE",
        product_type: "category_bb_textile",
        url: "/products/lange?variant=13045273985047"
      },
    
      "40279253254167": {
        variant_title: "Adèle",
        product_title: "le lange",
        price: '11.94',
        sku: "LAN.ABE",
        product_type: "category_bb_textile",
        url: "/products/lange?variant=40279253254167"
      },
    
      "40580396744727": {
        variant_title: "Edmond",
        product_title: "le lange",
        price: '11.94',
        sku: "LAN.ED",
        product_type: "category_bb_textile",
        url: "/products/lange?variant=40580396744727"
      },
    
      "12286416093207": {
        variant_title: "Roland",
        product_title: "le lange",
        price: '11.94',
        sku: "LAN.FR",
        product_type: "category_bb_textile",
        url: "/products/lange?variant=12286416093207"
      },
    
      "31151994372119": {
        variant_title: "RolandGrand",
        product_title: "le lange",
        price: '11.94',
        sku: "LAN.GD.FR",
        product_type: "category_bb_textile",
        url: "/products/lange?variant=31151994372119"
      },
    
      "31080221704215": {
        variant_title: "Ferdinand",
        product_title: "le lange",
        price: '11.94',
        sku: "LAN.FER",
        product_type: "category_bb_textile",
        url: "/products/lange?variant=31080221704215"
      },
    
      "30259183353879": {
        variant_title: "Hector",
        product_title: "le lange",
        price: '11.94',
        sku: "LAN.HEC",
        product_type: "category_bb_textile",
        url: "/products/lange?variant=30259183353879"
      },
    
      "39375527477271": {
        variant_title: "Mayeul",
        product_title: "le lange",
        price: '11.94',
        sku: "LAN.MAY",
        product_type: "category_bb_textile",
        url: "/products/lange?variant=39375527477271"
      },
    
      "40515195699223": {
        variant_title: "Andrea",
        product_title: "le lange",
        price: '11.94',
        sku: "LAN.AND",
        product_type: "category_bb_textile",
        url: "/products/lange?variant=40515195699223"
      },
    
      "12930604498967": {
        variant_title: "Leon",
        product_title: "le lange",
        price: '11.94',
        sku: "LAN.LE",
        product_type: "category_bb_textile",
        url: "/products/lange?variant=12930604498967"
      },
    
      "40373230731287": {
        variant_title: "William",
        product_title: "le lange",
        price: '11.94',
        sku: "LAN.HIP",
        product_type: "category_bb_textile",
        url: "/products/lange?variant=40373230731287"
      },
    
      "31232710672407": {
        variant_title: "Brigitte",
        product_title: "le lange",
        price: '19.90',
        sku: "LAN.RC",
        product_type: "category_bb_textile",
        url: "/products/lange?variant=31232710672407"
      },
    
      "39574926950423": {
        variant_title: "Barbara",
        product_title: "le lange",
        price: '11.94',
        sku: "LAN.BAR",
        product_type: "category_bb_textile",
        url: "/products/lange?variant=39574926950423"
      },
    
      "55241591161211": {
        variant_title: "Eau de Senteur",
        product_title: "le lange",
        price: '19.90',
        sku: "LAN.EDS",
        product_type: "category_bb_textile",
        url: "/products/lange?variant=55241591161211"
      },
    
  
    
      "12945710579735": {
        variant_title: "le liniment parfait (7ml)",
        product_title: "le liniment (7ml)",
        price: '0.00',
        sku: "ECH.LM",
        product_type: "",
        url: "/products/testeur-berlingot-10ml-liniment?variant=12945710579735"
      },
    
  
    
      "40150362357783": {
        variant_title: "Le liniment 500ml COSMOS ORGANIC",
        product_title: "Le liniment (COSMOS ORGANIC)",
        price: '11.90',
        sku: "LM4.IDV",
        product_type: "category_bb_cosmetics",
        url: "/products/le-liniment?variant=40150362357783"
      },
    
      "40150362390551": {
        variant_title: "La recharge 500ml COSMOS ORGANIC",
        product_title: "Le liniment (COSMOS ORGANIC)",
        price: '11.90',
        sku: "RECHARG.LM",
        product_type: "category_bb_cosmetics",
        url: "/products/le-liniment?variant=40150362390551"
      },
    
  
    
      "41609529032727": {
        variant_title: "Default Title",
        product_title: "Le liniment 100ML - COSMOS ORGANIC",
        price: '4.90',
        sku: "LM2.100.IDV",
        product_type: "category_bb_cosmetics",
        url: "/products/le-liniment-100ml?variant=41609529032727"
      },
    
  
    
      "33032115388439": {
        variant_title: "Default Title",
        product_title: "le Magazine JOONE",
        price: '0.00',
        sku: "LIV.GAM",
        product_type: "",
        url: "/products/livret-gamme-1?variant=33032115388439"
      },
    
  
    
      "40783244361751": {
        variant_title: "T1 (2 à 4 kg) - 30 couches FSC Mix*",
        product_title: "Le petit sac de couches Brigitte (FSC Mix*)",
        price: '10.90',
        sku: "S.SING.RC.PE.T1.OO",
        product_type: "category_bb_cosmetics",
        url: "/products/la-couche-iconique-sans-abonnement-brigitte?variant=40783244361751"
      },
    
      "40783244394519": {
        variant_title: "T2 (3 à 5 kg) - 32 couches FSC Mix*",
        product_title: "Le petit sac de couches Brigitte (FSC Mix*)",
        price: '10.90',
        sku: "S.SING.RC.PE.T2.OO",
        product_type: "category_bb_cosmetics",
        url: "/products/la-couche-iconique-sans-abonnement-brigitte?variant=40783244394519"
      },
    
      "40783244427287": {
        variant_title: "T3 (4 à 8 kg) - 27 couches FSC Mix*",
        product_title: "Le petit sac de couches Brigitte (FSC Mix*)",
        price: '10.90',
        sku: "S.SING.RC.IDV.T3.OO",
        product_type: "category_bb_cosmetics",
        url: "/products/la-couche-iconique-sans-abonnement-brigitte?variant=40783244427287"
      },
    
      "40783244460055": {
        variant_title: "T4 (7 à 14 kg) - 24 couches FSC Mix*",
        product_title: "Le petit sac de couches Brigitte (FSC Mix*)",
        price: '10.90',
        sku: "S.SING.RC.IDV.T4.OO",
        product_type: "category_bb_cosmetics",
        url: "/products/la-couche-iconique-sans-abonnement-brigitte?variant=40783244460055"
      },
    
      "40783244492823": {
        variant_title: "T5 (10 à 18 kg) - 20 couches FSC Mix*",
        product_title: "Le petit sac de couches Brigitte (FSC Mix*)",
        price: '10.90',
        sku: "S.SING.RC.IDV.T5.OO",
        product_type: "category_bb_cosmetics",
        url: "/products/la-couche-iconique-sans-abonnement-brigitte?variant=40783244492823"
      },
    
  
    
      "40143082586135": {
        variant_title: "T1 (2 à 4 kg) - 30 couches FSC Mix*",
        product_title: "Le petit sac de couches Malo (FSC Mix*)",
        price: '10.90',
        sku: "S.SING.ML.PE.T1.OO",
        product_type: "category_bb_cosmetics",
        url: "/products/paquet-de-couche?variant=40143082586135"
      },
    
      "40143082651671": {
        variant_title: "T2 (3 à 5 kg) - 32 couches FSC Mix*",
        product_title: "Le petit sac de couches Malo (FSC Mix*)",
        price: '10.90',
        sku: "S.SING.ML.PE.T2.OO",
        product_type: "category_bb_cosmetics",
        url: "/products/paquet-de-couche?variant=40143082651671"
      },
    
      "40143082717207": {
        variant_title: "T3 (4 à 8 kg) - 27 couches FSC Mix*",
        product_title: "Le petit sac de couches Malo (FSC Mix*)",
        price: '10.90',
        sku: "S.SING.ML.IDV.T3.OO",
        product_type: "category_bb_cosmetics",
        url: "/products/paquet-de-couche?variant=40143082717207"
      },
    
      "40143082782743": {
        variant_title: "T4 (7 à 14 kg) - 24 couches FSC Mix*",
        product_title: "Le petit sac de couches Malo (FSC Mix*)",
        price: '10.90',
        sku: "S.SING.ML.IDV.T4.OO",
        product_type: "category_bb_cosmetics",
        url: "/products/paquet-de-couche?variant=40143082782743"
      },
    
      "40143082848279": {
        variant_title: "T5 (10 à 18 kg) - 20 couches FSC Mix*",
        product_title: "Le petit sac de couches Malo (FSC Mix*)",
        price: '10.90',
        sku: "S.SING.ML.IDV.T5.OO",
        product_type: "category_bb_cosmetics",
        url: "/products/paquet-de-couche?variant=40143082848279"
      },
    
  
    
      "39379614892055": {
        variant_title: "Default Title",
        product_title: "le rituel hygiène & soin ados",
        price: '34.90',
        sku: "CF.KIDS8-12.RIT.HYG.SOIN",
        product_type: "category_bb_textile",
        url: "/products/coffret-soin-hygiene?variant=39379614892055"
      },
    
  
    
      "29385600630807": {
        variant_title: "Default Title",
        product_title: "Le rituel vergetures (COSMOS ORGANIC)",
        price: '54.90',
        sku: "CF.FM.ENC.PP",
        product_type: "category_wom_cosmetics",
        url: "/products/le-coffret-rituel-parfait-vergetures?variant=29385600630807"
      },
    
  
    
      "39370095001623": {
        variant_title: "Default Title",
        product_title: "le rituel visage ados - COSMOS ORGANIC",
        price: '27.90',
        sku: "CF.KIDS8-12.RIT.VIS",
        product_type: "category_bb_cosmetics",
        url: "/products/coffret-soin-visage-enfant?variant=39370095001623"
      },
    
  
    
      "39368654422039": {
        variant_title: "Default Title",
        product_title: "Le sac à dos JOONE x Mathilde Cabanas",
        price: '15.60',
        sku: "SAC.A.DOS1",
        product_type: "category_bb_textile",
        url: "/products/sac-a-dos-mathilde-cabanas?variant=39368654422039"
      },
    
  
    
      "39824385441815": {
        variant_title: "Sac garni / Malo / T1",
        product_title: "le sac à langer",
        price: '99.90',
        sku: "SAC.A.LANGER.C.ML.T1",
        product_type: "category_bb_textile",
        url: "/products/sac-a-langer-bebe?variant=39824385441815"
      },
    
      "40365339869207": {
        variant_title: "Sac garni / Malo / T2",
        product_title: "le sac à langer",
        price: '99.90',
        sku: "SAC.A.LANGER.C.ML.T2",
        product_type: "category_bb_textile",
        url: "/products/sac-a-langer-bebe?variant=40365339869207"
      },
    
      "40365339901975": {
        variant_title: "Sac garni / Malo / T3",
        product_title: "le sac à langer",
        price: '99.90',
        sku: "SAC.A.LANGER.C.ML.T3",
        product_type: "category_bb_textile",
        url: "/products/sac-a-langer-bebe?variant=40365339901975"
      },
    
      "40365339934743": {
        variant_title: "Sac garni / Brigitte / T1",
        product_title: "le sac à langer",
        price: '99.90',
        sku: "SAC.A.LANGER.C.RC.T1",
        product_type: "category_bb_textile",
        url: "/products/sac-a-langer-bebe?variant=40365339934743"
      },
    
      "40365339967511": {
        variant_title: "Sac garni / Brigitte / T2",
        product_title: "le sac à langer",
        price: '99.90',
        sku: "SAC.A.LANGER.C.RC.T2",
        product_type: "category_bb_textile",
        url: "/products/sac-a-langer-bebe?variant=40365339967511"
      },
    
      "40365340000279": {
        variant_title: "Sac garni / Brigitte / T3",
        product_title: "le sac à langer",
        price: '99.90',
        sku: "SAC.A.LANGER.C.RC.T3",
        product_type: "category_bb_textile",
        url: "/products/sac-a-langer-bebe?variant=40365340000279"
      },
    
      "39824385409047": {
        variant_title: "Sac seul / Malo / T1",
        product_title: "le sac à langer",
        price: '75.90',
        sku: "SAC.A.LANGER.V2",
        product_type: "category_bb_textile",
        url: "/products/sac-a-langer-bebe?variant=39824385409047"
      },
    
  
    
      "32915937230871": {
        variant_title: "Default Title",
        product_title: "le shampoing soin (COSMOS ORGANIC)",
        price: '12.90',
        sku: "SHAMP.CROUT.IDV",
        product_type: "category_bb_cosmetics",
        url: "/products/shampooing-croute-de-lait?variant=32915937230871"
      },
    
  
    
      "41008607264791": {
        variant_title: "6 mois",
        product_title: "Le t shirt anti UV",
        price: '34.90',
        sku: "TSHIRT.UV.MARIN.ZIP.6M",
        product_type: "category_bb_textile",
        url: "/products/t-shirt-anti-uv?variant=41008607264791"
      },
    
      "41008607330327": {
        variant_title: "12 mois",
        product_title: "Le t shirt anti UV",
        price: '34.90',
        sku: "TSHIRT.UV.MARIN.ZIP.12M",
        product_type: "category_bb_textile",
        url: "/products/t-shirt-anti-uv?variant=41008607330327"
      },
    
      "41008607363095": {
        variant_title: "18 mois",
        product_title: "Le t shirt anti UV",
        price: '34.90',
        sku: "TSHIRT.UV.MARIN.ZIP.18M",
        product_type: "category_bb_textile",
        url: "/products/t-shirt-anti-uv?variant=41008607363095"
      },
    
      "41008607428631": {
        variant_title: "24 mois",
        product_title: "Le t shirt anti UV",
        price: '34.90',
        sku: "TSHIRT.UV.MARIN.ZIP.24M",
        product_type: "category_bb_textile",
        url: "/products/t-shirt-anti-uv?variant=41008607428631"
      },
    
      "41008607461399": {
        variant_title: "36 mois",
        product_title: "Le t shirt anti UV",
        price: '34.90',
        sku: "TSHIRT.UV.MARIN.ZIP.36M",
        product_type: "category_bb_textile",
        url: "/products/t-shirt-anti-uv?variant=41008607461399"
      },
    
  
    
      "40086531473431": {
        variant_title: "18 mois / Simon",
        product_title: "le T-shirt anti-UV JOONE x Solette",
        price: '24.43',
        sku: "TSHIRT.UV.CITRON.18M",
        product_type: "category_bb_textile",
        url: "/products/t-shirt-anti-uv-solette-x-joone?variant=40086531473431"
      },
    
      "40086531506199": {
        variant_title: "24 mois / Simon",
        product_title: "le T-shirt anti-UV JOONE x Solette",
        price: '24.43',
        sku: "TSHIRT.UV.CITRON.24M",
        product_type: "category_bb_textile",
        url: "/products/t-shirt-anti-uv-solette-x-joone?variant=40086531506199"
      },
    
      "40086531538967": {
        variant_title: "36 mois / Simon",
        product_title: "le T-shirt anti-UV JOONE x Solette",
        price: '24.43',
        sku: "TSHIRT.UV.CITRON.36M",
        product_type: "category_bb_textile",
        url: "/products/t-shirt-anti-uv-solette-x-joone?variant=40086531538967"
      },
    
  
    
      "40044820660247": {
        variant_title: "Taille 36",
        product_title: "le vanity post-partum",
        price: '69.90',
        sku: "CF.VANITY.T36.CHEV",
        product_type: "category_wom_cosmetics",
        url: "/products/coffret-vanity-post-partum?variant=40044820660247"
      },
    
      "40044820725783": {
        variant_title: "Taille 38",
        product_title: "le vanity post-partum",
        price: '69.90',
        sku: "CF.VANITY.T38.CHEV",
        product_type: "category_wom_cosmetics",
        url: "/products/coffret-vanity-post-partum?variant=40044820725783"
      },
    
      "40044820791319": {
        variant_title: "Taille 40",
        product_title: "le vanity post-partum",
        price: '69.90',
        sku: "CF.VANITY.T40.CHEV",
        product_type: "category_wom_cosmetics",
        url: "/products/coffret-vanity-post-partum?variant=40044820791319"
      },
    
      "40044820856855": {
        variant_title: "Taille 42",
        product_title: "le vanity post-partum",
        price: '69.90',
        sku: "CF.VANITY.T42.CHEV",
        product_type: "category_wom_cosmetics",
        url: "/products/coffret-vanity-post-partum?variant=40044820856855"
      },
    
      "40044820922391": {
        variant_title: "Taille 44",
        product_title: "le vanity post-partum",
        price: '69.90',
        sku: "CF.VANITY.T44.CHEV",
        product_type: "category_wom_cosmetics",
        url: "/products/coffret-vanity-post-partum?variant=40044820922391"
      },
    
  
    
      "40874745397271": {
        variant_title: "Default Title",
        product_title: "Les 2 paquets de lingettes à l'eau compostables (COSMOS NATURAL)",
        price: '7.90',
        sku: "L5E.50.IDV",
        product_type: "category_bb_cosmetics",
        url: "/products/les-2-paquets-de-lingettes-compostables-cosmos-natural?variant=40874745397271"
      },
    
  
    
      "39393007075351": {
        variant_title: "50€",
        product_title: "les cartes cadeaux",
        price: '50.00',
        sku: "CARDS.KDO.NOEL2021-50",
        product_type: "",
        url: "/products/carte-cadeau?variant=39393007075351"
      },
    
      "39393007108119": {
        variant_title: "80€",
        product_title: "les cartes cadeaux",
        price: '80.00',
        sku: "CARDS.KDO.NOEL2021-80",
        product_type: "",
        url: "/products/carte-cadeau?variant=39393007108119"
      },
    
      "39393007140887": {
        variant_title: "140€",
        product_title: "les cartes cadeaux",
        price: '140.00',
        sku: "CARDS.KDO.NOEL2021-140",
        product_type: "",
        url: "/products/carte-cadeau?variant=39393007140887"
      },
    
  
    
      "40643739713559": {
        variant_title: "Default Title",
        product_title: "les cotons visage x80",
        price: '4.50',
        sku: "COTON.BB.80.IDV",
        product_type: "category_bb_cosmetics",
        url: "/products/les-cotons-visage-x80?variant=40643739713559"
      },
    
  
    
      "39331210559511": {
        variant_title: "Default Title",
        product_title: "les cotons x200",
        price: '5.90',
        sku: "COTON.BB.200.IDV",
        product_type: "category_bb_cosmetics",
        url: "/products/les-cotons-parfaits?variant=39331210559511"
      },
    
  
    
      "33047623991319": {
        variant_title: "Default Title",
        product_title: "les protège-slips",
        price: '5.90',
        sku: "FM.PROT.SLIP",
        product_type: "category_wom_cosmetics",
        url: "/products/les-protege-slips-parfaits?variant=33047623991319"
      },
    
  
    
      "39366933807127": {
        variant_title: "les protège-slips (2 unités)",
        product_title: "les protège-slips (2 unités)",
        price: '0.00',
        sku: "ECH.PROT.SLIP",
        product_type: "",
        url: "/products/echantillon-protege-slips?variant=39366933807127"
      },
    
  
    
      "31525850873879": {
        variant_title: "Boîte jour",
        product_title: "les serviettes hygiéniques",
        price: '5.90',
        sku: "SERV.HYG.DAY1",
        product_type: "",
        url: "/products/serviettes-hygieniques-parfaites?variant=31525850873879"
      },
    
      "31525850906647": {
        variant_title: "Boîte nuit",
        product_title: "les serviettes hygiéniques",
        price: '5.90',
        sku: "SERV.HYG.NIGHT1",
        product_type: "",
        url: "/products/serviettes-hygieniques-parfaites?variant=31525850906647"
      },
    
  
    
      "39366933217303": {
        variant_title: "les serviettes hygiéniques parfaites (1 jour et 1 nuit)",
        product_title: "les serviettes hygiéniques (1 jour 1 nuit)",
        price: '0.00',
        sku: "ECH.SERV.HYG.1D.1N",
        product_type: "",
        url: "/products/echantillon-serviettes-hygieniques-1-jour-1-nuit?variant=39366933217303"
      },
    
  
    
      "39346761007127": {
        variant_title: "Default Title",
        product_title: "Liniment Test 17.90",
        price: '17.90',
        sku: "LM-17.IDV",
        product_type: "",
        url: "/products/liniment-17-90?variant=39346761007127"
      },
    
  
    
      "53744954375": {
        variant_title: "Default Title",
        product_title: "Livraison Mondial Relay",
        price: '0.00',
        sku: "MONDIAL-RELAY",
        product_type: "category_freebie",
        url: "/products/livraison-mondial-relay?variant=53744954375"
      },
    
  
    
      "40536940970007": {
        variant_title: "Default Title",
        product_title: "Livre Boss Mama",
        price: '17.95',
        sku: "LIV.BOSSMAMA",
        product_type: "category_wom_cosmetics",
        url: "/products/livre-boss-mama?variant=40536940970007"
      },
    
  
    
      "39368729722903": {
        variant_title: "Default Title",
        product_title: "Livret One day in Joone",
        price: '0.00',
        sku: "LIV.ONEDAYINJOONE",
        product_type: "",
        url: "/products/livret-one-day-in-joone?variant=39368729722903"
      },
    
  
    
      "54872614895995": {
        variant_title: "Default Title",
        product_title: "Lot de lange",
        price: '35.82',
        sku: "LOT.LAN.V3",
        product_type: "",
        url: "/products/lot-de-lange?variant=54872614895995"
      },
    
  
    
      "32915942047767": {
        variant_title: "Default Title",
        product_title: "l’eau coiffante (COSMOS ORGANIC)",
        price: '12.90',
        sku: "EAU.COIF.IDV",
        product_type: "category_bb_cosmetics",
        url: "/products/eau-coiffante?variant=32915942047767"
      },
    
  
    
      "39329105903639": {
        variant_title: "Brosse à dents bleue",
        product_title: "ma 1ère brosse à dents",
        price: '5.90',
        sku: "BROSS.DENT.BLEU",
        product_type: "category_bb_cosmetics",
        url: "/products/brosse-a-dent-enfant?variant=39329105903639"
      },
    
      "39329105936407": {
        variant_title: "Brosse à dents orange",
        product_title: "ma 1ère brosse à dents",
        price: '5.90',
        sku: "BROSS.DENT.ORANG",
        product_type: "category_bb_cosmetics",
        url: "/products/brosse-a-dent-enfant?variant=39329105936407"
      },
    
  
    
      "33023667601431": {
        variant_title: "Default Title",
        product_title: "ma 1ère mousse lavante 2 en 1 (COSMOS ORGANIC)",
        price: '14.90',
        sku: "ENF.MOUS.LAV.IDV",
        product_type: "category_bb_cosmetics",
        url: "/products/mousse-lavante-enfant?variant=33023667601431"
      },
    
  
    
      "33022032150551": {
        variant_title: "Default Title",
        product_title: "Ma crème hydratante visage (COSMOS ORGANIC)",
        price: '19.90',
        sku: "ENF.CRM.VIS.IDV",
        product_type: "category_bb_cosmetics",
        url: "/products/creme-hydratante-visage-enfant?variant=33022032150551"
      },
    
  
    
      "33022052270103": {
        variant_title: "Default Title",
        product_title: "ma mousse nettoyante visage -	COSMOS ORGANIC",
        price: '12.90',
        sku: "ENF.MOUS.NETVIS.IDV",
        product_type: "category_bb_cosmetics",
        url: "/products/mousse-nettoyante-visage-enfant?variant=33022052270103"
      },
    
  
    
      "39317626290199": {
        variant_title: "2 ans / Malo",
        product_title: "mon 1er lot de 2 boxers",
        price: '7.56',
        sku: "BOXER.2.ML",
        product_type: "category_bb_textile",
        url: "/products/mon-1er-lot-de-2-boxers-parfaits?variant=39317626290199"
      },
    
      "39317626322967": {
        variant_title: "2 ans / Bernard",
        product_title: "mon 1er lot de 2 boxers",
        price: '7.56',
        sku: "BOXER.2.BE",
        product_type: "category_bb_textile",
        url: "/products/mon-1er-lot-de-2-boxers-parfaits?variant=39317626322967"
      },
    
      "39317626355735": {
        variant_title: "2 ans / Odette",
        product_title: "mon 1er lot de 2 boxers",
        price: '7.56',
        sku: "BOXER.2.P",
        product_type: "category_bb_textile",
        url: "/products/mon-1er-lot-de-2-boxers-parfaits?variant=39317626355735"
      },
    
      "39444687519767": {
        variant_title: "2 ans / Leon",
        product_title: "mon 1er lot de 2 boxers",
        price: '7.56',
        sku: "BOXER.2.LE",
        product_type: "category_bb_textile",
        url: "/products/mon-1er-lot-de-2-boxers-parfaits?variant=39444687519767"
      },
    
      "39317626388503": {
        variant_title: "3 ans / Malo",
        product_title: "mon 1er lot de 2 boxers",
        price: '7.56',
        sku: "BOXER.3.ML",
        product_type: "category_bb_textile",
        url: "/products/mon-1er-lot-de-2-boxers-parfaits?variant=39317626388503"
      },
    
      "39317626421271": {
        variant_title: "3 ans / Bernard",
        product_title: "mon 1er lot de 2 boxers",
        price: '7.56',
        sku: "BOXER.3.BE",
        product_type: "category_bb_textile",
        url: "/products/mon-1er-lot-de-2-boxers-parfaits?variant=39317626421271"
      },
    
      "39317626454039": {
        variant_title: "3 ans / Odette",
        product_title: "mon 1er lot de 2 boxers",
        price: '7.56',
        sku: "BOXER.3.P",
        product_type: "category_bb_textile",
        url: "/products/mon-1er-lot-de-2-boxers-parfaits?variant=39317626454039"
      },
    
      "39444687552535": {
        variant_title: "3 ans / Leon",
        product_title: "mon 1er lot de 2 boxers",
        price: '7.56',
        sku: "BOXER.3.LE",
        product_type: "category_bb_textile",
        url: "/products/mon-1er-lot-de-2-boxers-parfaits?variant=39444687552535"
      },
    
      "39317626486807": {
        variant_title: "4 ans / Malo",
        product_title: "mon 1er lot de 2 boxers",
        price: '7.56',
        sku: "BOXER.4.ML",
        product_type: "category_bb_textile",
        url: "/products/mon-1er-lot-de-2-boxers-parfaits?variant=39317626486807"
      },
    
      "39317626519575": {
        variant_title: "4 ans / Bernard",
        product_title: "mon 1er lot de 2 boxers",
        price: '7.56',
        sku: "BOXER.4.BE",
        product_type: "category_bb_textile",
        url: "/products/mon-1er-lot-de-2-boxers-parfaits?variant=39317626519575"
      },
    
      "39317626552343": {
        variant_title: "4 ans / Odette",
        product_title: "mon 1er lot de 2 boxers",
        price: '7.56',
        sku: "BOXER.4.P",
        product_type: "category_bb_textile",
        url: "/products/mon-1er-lot-de-2-boxers-parfaits?variant=39317626552343"
      },
    
      "39444687585303": {
        variant_title: "4 ans / Leon",
        product_title: "mon 1er lot de 2 boxers",
        price: '7.56',
        sku: "BOXER.4.LE",
        product_type: "category_bb_textile",
        url: "/products/mon-1er-lot-de-2-boxers-parfaits?variant=39444687585303"
      },
    
      "39461862866967": {
        variant_title: "5 ans / Malo",
        product_title: "mon 1er lot de 2 boxers",
        price: '7.56',
        sku: "BOXER.5.ML",
        product_type: "category_bb_textile",
        url: "/products/mon-1er-lot-de-2-boxers-parfaits?variant=39461862866967"
      },
    
      "39461862899735": {
        variant_title: "5 ans / Bernard",
        product_title: "mon 1er lot de 2 boxers",
        price: '7.56',
        sku: "BOXER.5.BE",
        product_type: "category_bb_textile",
        url: "/products/mon-1er-lot-de-2-boxers-parfaits?variant=39461862899735"
      },
    
      "39461862932503": {
        variant_title: "5 ans / Odette",
        product_title: "mon 1er lot de 2 boxers",
        price: '7.56',
        sku: "BOXER.5.P",
        product_type: "category_bb_textile",
        url: "/products/mon-1er-lot-de-2-boxers-parfaits?variant=39461862932503"
      },
    
      "39461862965271": {
        variant_title: "5 ans / Leon",
        product_title: "mon 1er lot de 2 boxers",
        price: '7.56',
        sku: "BOXER.5.LE",
        product_type: "category_bb_textile",
        url: "/products/mon-1er-lot-de-2-boxers-parfaits?variant=39461862965271"
      },
    
      "39461863129111": {
        variant_title: "6 ans / Malo",
        product_title: "mon 1er lot de 2 boxers",
        price: '7.56',
        sku: "BOXER.6.ML",
        product_type: "category_bb_textile",
        url: "/products/mon-1er-lot-de-2-boxers-parfaits?variant=39461863129111"
      },
    
      "39461863161879": {
        variant_title: "6 ans / Bernard",
        product_title: "mon 1er lot de 2 boxers",
        price: '7.56',
        sku: "BOXER.6.BE",
        product_type: "category_bb_textile",
        url: "/products/mon-1er-lot-de-2-boxers-parfaits?variant=39461863161879"
      },
    
      "39461863194647": {
        variant_title: "6 ans / Odette",
        product_title: "mon 1er lot de 2 boxers",
        price: '7.56',
        sku: "BOXER.6.P",
        product_type: "category_bb_textile",
        url: "/products/mon-1er-lot-de-2-boxers-parfaits?variant=39461863194647"
      },
    
      "39461863227415": {
        variant_title: "6 ans / Leon",
        product_title: "mon 1er lot de 2 boxers",
        price: '7.56',
        sku: "BOXER.6.LE",
        product_type: "category_bb_textile",
        url: "/products/mon-1er-lot-de-2-boxers-parfaits?variant=39461863227415"
      },
    
  
    
      "39317632745495": {
        variant_title: "2 ans / Brigitte",
        product_title: "mon 1er lot de 2 culottes",
        price: '5.96',
        sku: "CULOTTE.2.RC",
        product_type: "category_bb_textile",
        url: "/products/mon-1er-lot-de-culottes-parfaites?variant=39317632745495"
      },
    
      "39317632811031": {
        variant_title: "2 ans / Bernard",
        product_title: "mon 1er lot de 2 culottes",
        price: '5.96',
        sku: "CULOTTE.2.BE",
        product_type: "category_bb_textile",
        url: "/products/mon-1er-lot-de-culottes-parfaites?variant=39317632811031"
      },
    
      "39317632876567": {
        variant_title: "2 ans / Odette",
        product_title: "mon 1er lot de 2 culottes",
        price: '5.96',
        sku: "CULOTTE.2.P",
        product_type: "category_bb_textile",
        url: "/products/mon-1er-lot-de-culottes-parfaites?variant=39317632876567"
      },
    
      "39444681195543": {
        variant_title: "2 ans / Leon",
        product_title: "mon 1er lot de 2 culottes",
        price: '5.96',
        sku: "CULOTTE.2.LE",
        product_type: "category_bb_textile",
        url: "/products/mon-1er-lot-de-culottes-parfaites?variant=39444681195543"
      },
    
      "39317632942103": {
        variant_title: "3 ans / Brigitte",
        product_title: "mon 1er lot de 2 culottes",
        price: '5.96',
        sku: "CULOTTE.3.RC",
        product_type: "category_bb_textile",
        url: "/products/mon-1er-lot-de-culottes-parfaites?variant=39317632942103"
      },
    
      "39317633007639": {
        variant_title: "3 ans / Bernard",
        product_title: "mon 1er lot de 2 culottes",
        price: '5.96',
        sku: "CULOTTE.3.BE",
        product_type: "category_bb_textile",
        url: "/products/mon-1er-lot-de-culottes-parfaites?variant=39317633007639"
      },
    
      "39317633073175": {
        variant_title: "3 ans / Odette",
        product_title: "mon 1er lot de 2 culottes",
        price: '5.96',
        sku: "CULOTTE.3.P",
        product_type: "category_bb_textile",
        url: "/products/mon-1er-lot-de-culottes-parfaites?variant=39317633073175"
      },
    
      "39444681228311": {
        variant_title: "3 ans / Leon",
        product_title: "mon 1er lot de 2 culottes",
        price: '5.96',
        sku: "CULOTTE.3.LE",
        product_type: "category_bb_textile",
        url: "/products/mon-1er-lot-de-culottes-parfaites?variant=39444681228311"
      },
    
      "39317633138711": {
        variant_title: "4 ans / Brigitte",
        product_title: "mon 1er lot de 2 culottes",
        price: '14.90',
        sku: "CULOTTE.4.RC",
        product_type: "category_bb_textile",
        url: "/products/mon-1er-lot-de-culottes-parfaites?variant=39317633138711"
      },
    
      "39317633204247": {
        variant_title: "4 ans / Bernard",
        product_title: "mon 1er lot de 2 culottes",
        price: '5.96',
        sku: "CULOTTE.4.BE",
        product_type: "category_bb_textile",
        url: "/products/mon-1er-lot-de-culottes-parfaites?variant=39317633204247"
      },
    
      "39317633269783": {
        variant_title: "4 ans / Odette",
        product_title: "mon 1er lot de 2 culottes",
        price: '5.96',
        sku: "CULOTTE.4.P",
        product_type: "category_bb_textile",
        url: "/products/mon-1er-lot-de-culottes-parfaites?variant=39317633269783"
      },
    
      "39444681261079": {
        variant_title: "4 ans / Leon",
        product_title: "mon 1er lot de 2 culottes",
        price: '5.96',
        sku: "CULOTTE.4.LE",
        product_type: "category_bb_textile",
        url: "/products/mon-1er-lot-de-culottes-parfaites?variant=39444681261079"
      },
    
      "39461860212759": {
        variant_title: "5 ans / Brigitte",
        product_title: "mon 1er lot de 2 culottes",
        price: '5.96',
        sku: "CULOTTE.5.RC",
        product_type: "category_bb_textile",
        url: "/products/mon-1er-lot-de-culottes-parfaites?variant=39461860212759"
      },
    
      "39461860245527": {
        variant_title: "5 ans / Bernard",
        product_title: "mon 1er lot de 2 culottes",
        price: '5.96',
        sku: "CULOTTE.5.BE",
        product_type: "category_bb_textile",
        url: "/products/mon-1er-lot-de-culottes-parfaites?variant=39461860245527"
      },
    
      "39461860278295": {
        variant_title: "5 ans / Odette",
        product_title: "mon 1er lot de 2 culottes",
        price: '5.96',
        sku: "CULOTTE.5.P",
        product_type: "category_bb_textile",
        url: "/products/mon-1er-lot-de-culottes-parfaites?variant=39461860278295"
      },
    
      "39461860311063": {
        variant_title: "5 ans / Leon",
        product_title: "mon 1er lot de 2 culottes",
        price: '5.96',
        sku: "CULOTTE.5.LE",
        product_type: "category_bb_textile",
        url: "/products/mon-1er-lot-de-culottes-parfaites?variant=39461860311063"
      },
    
      "39461861163031": {
        variant_title: "6 ans / Brigitte",
        product_title: "mon 1er lot de 2 culottes",
        price: '5.96',
        sku: "CULOTTE.6.RC",
        product_type: "category_bb_textile",
        url: "/products/mon-1er-lot-de-culottes-parfaites?variant=39461861163031"
      },
    
      "39461861195799": {
        variant_title: "6 ans / Bernard",
        product_title: "mon 1er lot de 2 culottes",
        price: '5.96',
        sku: "CULOTTE.6.BE",
        product_type: "category_bb_textile",
        url: "/products/mon-1er-lot-de-culottes-parfaites?variant=39461861195799"
      },
    
      "39461861228567": {
        variant_title: "6 ans / Odette",
        product_title: "mon 1er lot de 2 culottes",
        price: '5.96',
        sku: "CULOTTE.6.P",
        product_type: "category_bb_textile",
        url: "/products/mon-1er-lot-de-culottes-parfaites?variant=39461861228567"
      },
    
      "39461861261335": {
        variant_title: "6 ans / Leon",
        product_title: "mon 1er lot de 2 culottes",
        price: '5.96',
        sku: "CULOTTE.6.LE",
        product_type: "category_bb_textile",
        url: "/products/mon-1er-lot-de-culottes-parfaites?variant=39461861261335"
      },
    
  
    
      "53526743744891": {
        variant_title: "S",
        product_title: "Pull Joone Paris",
        price: '69.00',
        sku: "PULL.JOONE.S",
        product_type: "",
        url: "/products/pull-joone-paris?variant=53526743744891"
      },
    
      "53526743777659": {
        variant_title: "M",
        product_title: "Pull Joone Paris",
        price: '69.00',
        sku: "PULL.JOONE.M",
        product_type: "",
        url: "/products/pull-joone-paris?variant=53526743777659"
      },
    
      "53526743810427": {
        variant_title: "L",
        product_title: "Pull Joone Paris",
        price: '69.00',
        sku: "PULL.JOONE.L",
        product_type: "",
        url: "/products/pull-joone-paris?variant=53526743810427"
      },
    
      "53526743843195": {
        variant_title: "XL",
        product_title: "Pull Joone Paris",
        price: '69.00',
        sku: "PULL.JOONE.XL",
        product_type: "",
        url: "/products/pull-joone-paris?variant=53526743843195"
      },
    
  
    
      "31470578401303": {
        variant_title: "Brigitte / T1  (2 à 4 kg) - 30 COUCHES FSC Mix*",
        product_title: "Sac de couches FSC Mix* - spécial opération de parrainage",
        price: '10.90',
        sku: "S.SING.RC.T1-OP",
        product_type: "",
        url: "/products/sac-de-couches-special-operation-de-parrainage?variant=31470578401303"
      },
    
      "31470578434071": {
        variant_title: "Brigitte / T2 (3 à 5 kg) - 32 COUCHES FSC Mix*",
        product_title: "Sac de couches FSC Mix* - spécial opération de parrainage",
        price: '10.90',
        sku: "S.SING.RC.T2-OP",
        product_type: "",
        url: "/products/sac-de-couches-special-operation-de-parrainage?variant=31470578434071"
      },
    
      "31470578466839": {
        variant_title: "Brigitte / T3 (4 à 8 kg) - 27 COUCHES FSC Mix*",
        product_title: "Sac de couches FSC Mix* - spécial opération de parrainage",
        price: '10.90',
        sku: "S.SING.RC.T3-OP",
        product_type: "",
        url: "/products/sac-de-couches-special-operation-de-parrainage?variant=31470578466839"
      },
    
      "31470578499607": {
        variant_title: "Brigitte / T4 (7 à 14 kg) - 24 COUCHES FSC Mix*",
        product_title: "Sac de couches FSC Mix* - spécial opération de parrainage",
        price: '10.90',
        sku: "S.SING.RC.T4-OP",
        product_type: "",
        url: "/products/sac-de-couches-special-operation-de-parrainage?variant=31470578499607"
      },
    
      "31470578532375": {
        variant_title: "Brigitte / T5  (10 à 18 kg) - 20 COUCHES FSC Mix*",
        product_title: "Sac de couches FSC Mix* - spécial opération de parrainage",
        price: '10.90',
        sku: "S.SING.RC.T5-OP",
        product_type: "",
        url: "/products/sac-de-couches-special-operation-de-parrainage?variant=31470578532375"
      },
    
      "31470578565143": {
        variant_title: "Malo / T1  (2 à 4 kg) - 30 COUCHES FSC Mix*",
        product_title: "Sac de couches FSC Mix* - spécial opération de parrainage",
        price: '10.90',
        sku: "S.SING.ML.T1-OP",
        product_type: "",
        url: "/products/sac-de-couches-special-operation-de-parrainage?variant=31470578565143"
      },
    
      "31470578597911": {
        variant_title: "Malo / T2 (3 à 5 kg) - 32 COUCHES FSC Mix*",
        product_title: "Sac de couches FSC Mix* - spécial opération de parrainage",
        price: '10.90',
        sku: "S.SING.ML.T2-OP",
        product_type: "",
        url: "/products/sac-de-couches-special-operation-de-parrainage?variant=31470578597911"
      },
    
      "31470578630679": {
        variant_title: "Malo / T3 (4 à 8 kg) - 27 COUCHES FSC Mix*",
        product_title: "Sac de couches FSC Mix* - spécial opération de parrainage",
        price: '10.90',
        sku: "S.SING.ML.T3-OP",
        product_type: "",
        url: "/products/sac-de-couches-special-operation-de-parrainage?variant=31470578630679"
      },
    
      "31470578663447": {
        variant_title: "Malo / T4 (7 à 14 kg) - 24 COUCHES FSC Mix*",
        product_title: "Sac de couches FSC Mix* - spécial opération de parrainage",
        price: '10.90',
        sku: "S.SING.ML.T4-OP",
        product_type: "",
        url: "/products/sac-de-couches-special-operation-de-parrainage?variant=31470578663447"
      },
    
      "31470578696215": {
        variant_title: "Malo / T5  (10 à 18 kg) - 20 COUCHES FSC Mix*",
        product_title: "Sac de couches FSC Mix* - spécial opération de parrainage",
        price: '10.90',
        sku: "S.SING.ML.T5-OP",
        product_type: "",
        url: "/products/sac-de-couches-special-operation-de-parrainage?variant=31470578696215"
      },
    
  
    
      "39325096345623": {
        variant_title: "Default Title",
        product_title: "Sticker Bébé à Bord",
        price: '4.90',
        sku: "PF.STICK.BB.A.BORD1",
        product_type: "",
        url: "/products/sticker-bebe-a-bord?variant=39325096345623"
      },
    
  
    
      "39351238688791": {
        variant_title: "Default Title",
        product_title: "Test Asile Colis",
        price: '20.00',
        sku: "TEST-ASILE",
        product_type: "",
        url: "/products/test-asile-colis?variant=39351238688791"
      },
    
  
    
      "39351714906135": {
        variant_title: "T1 (2 à 4 kg) FSC Mix*",
        product_title: "Un jour en JOONE - France",
        price: '0.00',
        sku: "CF.ONEDAYINJOONE.PHOME.T1",
        product_type: "category_odij",
        url: "/products/kit-essai-couche?variant=39351714906135"
      },
    
      "39351714971671": {
        variant_title: "T2 (3 à 5 kg) FSC Mix*",
        product_title: "Un jour en JOONE - France",
        price: '0.00',
        sku: "CF.ONEDAYINJOONE.T2",
        product_type: "category_odij",
        url: "/products/kit-essai-couche?variant=39351714971671"
      },
    
      "39351714938903": {
        variant_title: "T3 (4 à 8 kg) FSC Mix*",
        product_title: "Un jour en JOONE - France",
        price: '0.00',
        sku: "CF.ONEDAYINJOONE.T3",
        product_type: "category_odij",
        url: "/products/kit-essai-couche?variant=39351714938903"
      },
    
      "39351715004439": {
        variant_title: "T4 (7 à 14 kg) FSC Mix*",
        product_title: "Un jour en JOONE - France",
        price: '0.00',
        sku: "CF.ONEDAYINJOONE.T4",
        product_type: "category_odij",
        url: "/products/kit-essai-couche?variant=39351715004439"
      },
    
  
    
      "40611454844951": {
        variant_title: "Default Title",
        product_title: "Veilleuse renard",
        price: '13.93',
        sku: "VEILLEUSE.BE",
        product_type: "",
        url: "/products/veilleuse-bernard-marketplace?variant=40611454844951"
      },
    
  
    
      "13186522546199": {
        variant_title: "T1  (2 à 4 kg) - 180 COUCHES / Brigitte",
        product_title: "VOTRE ABONNEMENT COUCHES PERSONNALISÉ",
        price: '64.90',
        sku: "B.RC.PE.T1",
        product_type: "category_bb_hygiene",
        url: "/products/couches-joone-2?variant=13186522546199"
      },
    
      "13186545385495": {
        variant_title: "T1  (2 à 4 kg) - 180 COUCHES / Malo",
        product_title: "VOTRE ABONNEMENT COUCHES PERSONNALISÉ",
        price: '64.90',
        sku: "B.ML.PE.T1",
        product_type: "category_bb_hygiene",
        url: "/products/couches-joone-2?variant=13186545385495"
      },
    
      "5423571566625": {
        variant_title: "T1  (2 à 4 kg) - 180 COUCHES / Blanc",
        product_title: "VOTRE ABONNEMENT COUCHES PERSONNALISÉ",
        price: '64.90',
        sku: "B.BL.PE.T1",
        product_type: "category_bb_hygiene",
        url: "/products/couches-joone-2?variant=5423571566625"
      },
    
      "12256211992599": {
        variant_title: "T2  (3 à 5 kg) - 192 COUCHES / Brigitte",
        product_title: "VOTRE ABONNEMENT COUCHES PERSONNALISÉ",
        price: '64.90',
        sku: "B.RC.PE.T2",
        product_type: "category_bb_hygiene",
        url: "/products/couches-joone-2?variant=12256211992599"
      },
    
      "13186545451031": {
        variant_title: "T2  (3 à 5 kg) - 192 COUCHES / Malo",
        product_title: "VOTRE ABONNEMENT COUCHES PERSONNALISÉ",
        price: '64.90',
        sku: "B.ML.PE.T2",
        product_type: "category_bb_hygiene",
        url: "/products/couches-joone-2?variant=13186545451031"
      },
    
      "12769724497943": {
        variant_title: "T2  (3 à 5 kg) - 192 COUCHES / Bernard",
        product_title: "VOTRE ABONNEMENT COUCHES PERSONNALISÉ",
        price: '64.90',
        sku: "B.BE.PE.T2",
        product_type: "category_bb_hygiene",
        url: "/products/couches-joone-2?variant=12769724497943"
      },
    
      "13009299570711": {
        variant_title: "T2  (3 à 5 kg) - 192 COUCHES / Leon",
        product_title: "VOTRE ABONNEMENT COUCHES PERSONNALISÉ",
        price: '64.90',
        sku: "B.LE.PE.T2",
        product_type: "category_bb_hygiene",
        url: "/products/couches-joone-2?variant=13009299570711"
      },
    
      "27936758333463": {
        variant_title: "T2  (3 à 5 kg) - 192 COUCHES / Barbara",
        product_title: "VOTRE ABONNEMENT COUCHES PERSONNALISÉ",
        price: '64.90',
        sku: "B.BAR.PE.T2",
        product_type: "category_bb_hygiene",
        url: "/products/couches-joone-2?variant=27936758333463"
      },
    
      "40373220081687": {
        variant_title: "T2  (3 à 5 kg) - 192 COUCHES / William",
        product_title: "VOTRE ABONNEMENT COUCHES PERSONNALISÉ",
        price: '64.90',
        sku: "B.HIP.PE.T2",
        product_type: "category_bb_hygiene",
        url: "/products/couches-joone-2?variant=40373220081687"
      },
    
      "40587019911191": {
        variant_title: "T2  (3 à 5 kg) - 192 COUCHES / Edmond",
        product_title: "VOTRE ABONNEMENT COUCHES PERSONNALISÉ",
        price: '64.90',
        sku: "B.ED.PE.T2",
        product_type: "category_bb_hygiene",
        url: "/products/couches-joone-2?variant=40587019911191"
      },
    
      "12256216186903": {
        variant_title: "T3 (4 à 8 kg) - 162 COUCHES / Brigitte",
        product_title: "VOTRE ABONNEMENT COUCHES PERSONNALISÉ",
        price: '64.90',
        sku: "B.RC.IDV.T3",
        product_type: "category_bb_hygiene",
        url: "/products/couches-joone-2?variant=12256216186903"
      },
    
      "13186545483799": {
        variant_title: "T3 (4 à 8 kg) - 162 COUCHES / Malo",
        product_title: "VOTRE ABONNEMENT COUCHES PERSONNALISÉ",
        price: '64.90',
        sku: "B.ML.IDV.T3",
        product_type: "category_bb_hygiene",
        url: "/products/couches-joone-2?variant=13186545483799"
      },
    
      "12769730428951": {
        variant_title: "T3 (4 à 8 kg) - 162 COUCHES / Bernard",
        product_title: "VOTRE ABONNEMENT COUCHES PERSONNALISÉ",
        price: '64.90',
        sku: "B.BE.IDV.T3",
        product_type: "category_bb_hygiene",
        url: "/products/couches-joone-2?variant=12769730428951"
      },
    
      "13009300389911": {
        variant_title: "T3 (4 à 8 kg) - 162 COUCHES / Leon",
        product_title: "VOTRE ABONNEMENT COUCHES PERSONNALISÉ",
        price: '64.90',
        sku: "B.LE.IDV.T3",
        product_type: "category_bb_hygiene",
        url: "/products/couches-joone-2?variant=13009300389911"
      },
    
      "27936758366231": {
        variant_title: "T3 (4 à 8 kg) - 162 COUCHES / Barbara",
        product_title: "VOTRE ABONNEMENT COUCHES PERSONNALISÉ",
        price: '64.90',
        sku: "B.BAR.IDV.T3",
        product_type: "category_bb_hygiene",
        url: "/products/couches-joone-2?variant=27936758366231"
      },
    
      "40373220114455": {
        variant_title: "T3 (4 à 8 kg) - 162 COUCHES / William",
        product_title: "VOTRE ABONNEMENT COUCHES PERSONNALISÉ",
        price: '64.90',
        sku: "B.HIP.PE.T3",
        product_type: "category_bb_hygiene",
        url: "/products/couches-joone-2?variant=40373220114455"
      },
    
      "40587019943959": {
        variant_title: "T3 (4 à 8 kg) - 162 COUCHES / Edmond",
        product_title: "VOTRE ABONNEMENT COUCHES PERSONNALISÉ",
        price: '64.90',
        sku: "B.ED.PE.T3",
        product_type: "category_bb_hygiene",
        url: "/products/couches-joone-2?variant=40587019943959"
      },
    
      "55475013575": {
        variant_title: "T3 (4 à 8 kg) - 162 COUCHES / Odette",
        product_title: "VOTRE ABONNEMENT COUCHES PERSONNALISÉ",
        price: '64.90',
        sku: "B.P.IDV.T3",
        product_type: "category_bb_hygiene",
        url: "/products/couches-joone-2?variant=55475013575"
      },
    
      "40768630685719": {
        variant_title: "T3 (4 à 8 kg) - 162 COUCHES / Tribu de Noel",
        product_title: "VOTRE ABONNEMENT COUCHES PERSONNALISÉ",
        price: '64.90',
        sku: "B.TNO.IDV.T3",
        product_type: "category_bb_hygiene",
        url: "/products/couches-joone-2?variant=40768630685719"
      },
    
      "12256219627543": {
        variant_title: "T4 (7 à 14 kg) - 144 COUCHES / Brigitte",
        product_title: "VOTRE ABONNEMENT COUCHES PERSONNALISÉ",
        price: '64.90',
        sku: "B.RC.IDV.T4",
        product_type: "category_bb_hygiene",
        url: "/products/couches-joone-2?variant=12256219627543"
      },
    
      "13186545549335": {
        variant_title: "T4 (7 à 14 kg) - 144 COUCHES / Malo",
        product_title: "VOTRE ABONNEMENT COUCHES PERSONNALISÉ",
        price: '64.90',
        sku: "B.ML.IDV.T4",
        product_type: "category_bb_hygiene",
        url: "/products/couches-joone-2?variant=13186545549335"
      },
    
      "12769731608599": {
        variant_title: "T4 (7 à 14 kg) - 144 COUCHES / Bernard",
        product_title: "VOTRE ABONNEMENT COUCHES PERSONNALISÉ",
        price: '64.90',
        sku: "B.BE.IDV.T4",
        product_type: "category_bb_hygiene",
        url: "/products/couches-joone-2?variant=12769731608599"
      },
    
      "12924636430359": {
        variant_title: "T4 (7 à 14 kg) - 144 COUCHES / Leon",
        product_title: "VOTRE ABONNEMENT COUCHES PERSONNALISÉ",
        price: '64.90',
        sku: "B.LE.IDV.T4",
        product_type: "category_bb_hygiene",
        url: "/products/couches-joone-2?variant=12924636430359"
      },
    
      "27936758398999": {
        variant_title: "T4 (7 à 14 kg) - 144 COUCHES / Barbara",
        product_title: "VOTRE ABONNEMENT COUCHES PERSONNALISÉ",
        price: '64.90',
        sku: "B.BAR.IDV.T4",
        product_type: "category_bb_hygiene",
        url: "/products/couches-joone-2?variant=27936758398999"
      },
    
      "40373220147223": {
        variant_title: "T4 (7 à 14 kg) - 144 COUCHES / William",
        product_title: "VOTRE ABONNEMENT COUCHES PERSONNALISÉ",
        price: '64.90',
        sku: "B.HIP.PE.T4",
        product_type: "category_bb_hygiene",
        url: "/products/couches-joone-2?variant=40373220147223"
      },
    
      "40587019976727": {
        variant_title: "T4 (7 à 14 kg) - 144 COUCHES / Edmond",
        product_title: "VOTRE ABONNEMENT COUCHES PERSONNALISÉ",
        price: '64.90',
        sku: "B.ED.PE.T4",
        product_type: "category_bb_hygiene",
        url: "/products/couches-joone-2?variant=40587019976727"
      },
    
      "55475013831": {
        variant_title: "T4 (7 à 14 kg) - 144 COUCHES / Odette",
        product_title: "VOTRE ABONNEMENT COUCHES PERSONNALISÉ",
        price: '64.90',
        sku: "B.P.IDV.T4",
        product_type: "category_bb_hygiene",
        url: "/products/couches-joone-2?variant=55475013831"
      },
    
      "40768630718487": {
        variant_title: "T4 (7 à 14 kg) - 144 COUCHES / Tribu de Noel",
        product_title: "VOTRE ABONNEMENT COUCHES PERSONNALISÉ",
        price: '64.90',
        sku: "B.TNO.IDV.T4",
        product_type: "category_bb_hygiene",
        url: "/products/couches-joone-2?variant=40768630718487"
      },
    
      "5059524362273": {
        variant_title: "T5  (10 à 18 kg) - 120 COUCHES / Brigitte",
        product_title: "VOTRE ABONNEMENT COUCHES PERSONNALISÉ",
        price: '64.90',
        sku: "B.RC.IDV.T5",
        product_type: "category_bb_hygiene",
        url: "/products/couches-joone-2?variant=5059524362273"
      },
    
      "13186545582103": {
        variant_title: "T5  (10 à 18 kg) - 120 COUCHES / Malo",
        product_title: "VOTRE ABONNEMENT COUCHES PERSONNALISÉ",
        price: '64.90',
        sku: "B.ML.IDV.T5",
        product_type: "category_bb_hygiene",
        url: "/products/couches-joone-2?variant=13186545582103"
      },
    
      "12769734361111": {
        variant_title: "T5  (10 à 18 kg) - 120 COUCHES / Bernard",
        product_title: "VOTRE ABONNEMENT COUCHES PERSONNALISÉ",
        price: '64.90',
        sku: "B.BE.IDV.T5",
        product_type: "category_bb_hygiene",
        url: "/products/couches-joone-2?variant=12769734361111"
      },
    
      "12924637642775": {
        variant_title: "T5  (10 à 18 kg) - 120 COUCHES / Leon",
        product_title: "VOTRE ABONNEMENT COUCHES PERSONNALISÉ",
        price: '64.90',
        sku: "B.LE.IDV.T5",
        product_type: "category_bb_hygiene",
        url: "/products/couches-joone-2?variant=12924637642775"
      },
    
      "27936758431767": {
        variant_title: "T5  (10 à 18 kg) - 120 COUCHES / Barbara",
        product_title: "VOTRE ABONNEMENT COUCHES PERSONNALISÉ",
        price: '64.90',
        sku: "B.BAR.IDV.T5",
        product_type: "category_bb_hygiene",
        url: "/products/couches-joone-2?variant=27936758431767"
      },
    
      "40373220179991": {
        variant_title: "T5  (10 à 18 kg) - 120 COUCHES / William",
        product_title: "VOTRE ABONNEMENT COUCHES PERSONNALISÉ",
        price: '64.90',
        sku: "B.HIP.PE.T5",
        product_type: "category_bb_hygiene",
        url: "/products/couches-joone-2?variant=40373220179991"
      },
    
      "40587020009495": {
        variant_title: "T5  (10 à 18 kg) - 120 COUCHES / Edmond",
        product_title: "VOTRE ABONNEMENT COUCHES PERSONNALISÉ",
        price: '64.90',
        sku: "B.ED.PE.T5",
        product_type: "category_bb_hygiene",
        url: "/products/couches-joone-2?variant=40587020009495"
      },
    
      "13316340645911": {
        variant_title: "T5  (10 à 18 kg) - 120 COUCHES / Odette",
        product_title: "VOTRE ABONNEMENT COUCHES PERSONNALISÉ",
        price: '64.90',
        sku: "B.P.IDV.T5",
        product_type: "category_bb_hygiene",
        url: "/products/couches-joone-2?variant=13316340645911"
      },
    
      "40768630751255": {
        variant_title: "T5  (10 à 18 kg) - 120 COUCHES / Tribu de Noel",
        product_title: "VOTRE ABONNEMENT COUCHES PERSONNALISÉ",
        price: '64.90',
        sku: "B.TNO.IDV.T5",
        product_type: "category_bb_hygiene",
        url: "/products/couches-joone-2?variant=40768630751255"
      },
    
      "12769737211927": {
        variant_title: "T6 (16 à 30 kg) - 114 COUCHES / Bernard",
        product_title: "VOTRE ABONNEMENT COUCHES PERSONNALISÉ",
        price: '64.90',
        sku: "B.BE.IDV.T6",
        product_type: "category_bb_hygiene",
        url: "/products/couches-joone-2?variant=12769737211927"
      },
    
      "13009297178647": {
        variant_title: "T6 (16 à 30 kg) - 114 COUCHES / Leon",
        product_title: "VOTRE ABONNEMENT COUCHES PERSONNALISÉ",
        price: '64.90',
        sku: "B.LE.IDV.T6",
        product_type: "category_bb_hygiene",
        url: "/products/couches-joone-2?variant=13009297178647"
      },
    
      "33023785992215": {
        variant_title: "T6 (16 à 30 kg) - 114 COUCHES / Barbara",
        product_title: "VOTRE ABONNEMENT COUCHES PERSONNALISÉ",
        price: '64.90',
        sku: "B.BAR.IDV.T6",
        product_type: "category_bb_hygiene",
        url: "/products/couches-joone-2?variant=33023785992215"
      },
    
      "40373220212759": {
        variant_title: "T6 (16 à 30 kg) - 114 COUCHES / William",
        product_title: "VOTRE ABONNEMENT COUCHES PERSONNALISÉ",
        price: '64.90',
        sku: "B.HIP.PE.T6",
        product_type: "category_bb_hygiene",
        url: "/products/couches-joone-2?variant=40373220212759"
      },
    
      "40587020042263": {
        variant_title: "T6 (16 à 30 kg) - 114 COUCHES / Edmond",
        product_title: "VOTRE ABONNEMENT COUCHES PERSONNALISÉ",
        price: '64.90',
        sku: "B.ED.PE.T6",
        product_type: "category_bb_hygiene",
        url: "/products/couches-joone-2?variant=40587020042263"
      },
    
      "40768630784023": {
        variant_title: "T6 (16 à 30 kg) - 114 COUCHES / Tribu de Noel",
        product_title: "VOTRE ABONNEMENT COUCHES PERSONNALISÉ",
        price: '64.90',
        sku: "B.TNO.IDV.T6",
        product_type: "category_bb_hygiene",
        url: "/products/couches-joone-2?variant=40768630784023"
      },
    
  

};
